<div class="container-fluid rx-page mt-2">
  <p-confirmDialog
    styleClass="rx-confirm-dialog"
    [appendTo]="'body'"
    [style]="{ width: 'min(420px, 92vw)' }"
  ></p-confirmDialog>

  <div class="rx-top-chrome">
    <nav class="rx-toolbar" aria-label="Prescription actions">
      <div class="rx-toolbar-rail">
        <div class="rx-toolbar-group" aria-label="Patient actions">
          <button
            type="button"
            class="rx-chip rx-chip--queue"
            [class.is-active]="isPatientVisible"
            (click)="openQueueSidebar()"
            aria-label="Open patient queue"
            pTooltip="Today's patient queue&#10;Shows all appointments for the current session"
            tooltipPosition="bottom"
            [tooltipOptions]="{ showDelay: 600 }"
          >
            <i class="pi pi-users" aria-hidden="true"></i>
            <span>Queue</span>
            <span class="rx-chip-badge" *ngIf="consultationQueueCount > 0">{{
              consultationQueueCount
            }}</span>
            <span
              class="queue-alert-dot"
              *ngIf="queueAlerts.length > 0 && !isPatientVisible"
              pTooltip="Patients waiting at another clinic"
              tooltipPosition="bottom"
            ></span>
          </button>
          <button
            type="button"
            class="rx-chip rx-chip--add"
            (click)="openQuickAddDialog()"
            aria-label="Add patient"
            pTooltip="Add a new patient to today's queue&#10;Shortcut: Alt + A"
            tooltipPosition="bottom"
            [tooltipOptions]="{ showDelay: 600 }"
          >
            <i class="pi pi-user-plus" aria-hidden="true"></i>
            <span>Add</span>
          </button>
        </div>

        <span class="rx-toolbar-sep" aria-hidden="true"></span>

        <div class="rx-toolbar-group" aria-label="Workflow actions">
          <button
            type="button"
            class="rx-chip rx-chip--medicine"
            [class.is-active]="isMedicineVisible"
            (click)="openMedicineQueueSidebar()"
            aria-label="Open medicine queue"
            pTooltip="Medicine collection queue&#10;Track which prescriptions are ready for pickup&#10;Shortcut: Alt + M"
            tooltipPosition="bottom"
            [tooltipOptions]="{ showDelay: 600 }"
          >
            <i class="pi pi-inbox" aria-hidden="true"></i>
            <span>Medicine</span>
          </button>
          <!-- Notes toolbar button (hidden — keep for later restore)
          <button
            type="button"
            class="rx-chip rx-chip--notes"
            (click)="openNotesDialog()"
            aria-label="Open doctor notes"
            [disabled]="!hasSelectedPatient"
            pTooltip="Doctor notes for the current patient&#10;Shortcut: Alt + H"
            tooltipPosition="bottom"
            [tooltipOptions]="{ showDelay: 600 }"
          >
            <i class="pi pi-file-edit" aria-hidden="true"></i>
            <span>Notes</span>
          </button>
          -->
        </div>

        <span class="rx-toolbar-sep" aria-hidden="true"></span>

        <div class="rx-toolbar-group" aria-label="Help">
          <button
            type="button"
            class="rx-chip rx-chip--help"
            [class.is-active]="hotkeysHelpVisible"
            (click)="hotkeysHelpVisible = true"
            aria-label="Keyboard shortcuts. Press Alt plus slash to open."
            pTooltip="View all keyboard shortcuts&#10;Shortcut: Alt + /"
            tooltipPosition="bottom"
            [tooltipOptions]="{ showDelay: 600 }"
          >
            <i class="pi pi-question-circle" aria-hidden="true"></i>
            <span>Shortcuts</span>
            <span class="rx-chip-keys" aria-hidden="true">
              <kbd>Alt</kbd><span>+</span><kbd>/</kbd>
            </span>
          </button>
        </div>
      </div>
    </nav>

    <div class="rx-top-divider" aria-hidden="true"></div>

    <div class="rx-header-search">
      <div class="rx-header-search__field custom-autocomplete">
        <i class="pi pi-search rx-header-search__icon" aria-hidden="true"></i>
        <p-autoComplete
          #headerPatientSearchAuto
          inputId="headerPatientSearch"
          [(ngModel)]="selectedPatient"
          [suggestions]="patientsList"
          (completeMethod)="searchPatients($event)"
          (onSelect)="onPatientSelect($event)"
          field="search_label"
          placeholder="Find patient — name, number, or phone (Alt+F)"
          [forceSelection]="true"
          [dropdown]="false"
          [minLength]="2"
          emptyMessage="No patients found"
          styleClass="rx-patient-search-ac rx-header-search-ac"
          panelStyleClass="rx-patient-search-panel"
          appendTo="body"
          aria-label="Find patient"
        >
          <ng-template let-patient pTemplate="item">
            <div
              class="rx-search-result"
              [class.rx-search-result--free]="patient.is_free"
            >
              <span class="rx-search-result__avatar" aria-hidden="true">
                {{ getPatientInitials(patient.full_name) }}
              </span>
              <div class="rx-search-result__main">
                <div class="rx-search-result__name-row">
                  <span class="rx-search-result__name">{{
                    patient.full_name
                  }}</span>
                  <span
                    class="rx-search-result__badge"
                    *ngIf="patient.is_free"
                  >
                    Free visit
                  </span>
                </div>
                <div
                  class="rx-search-result__details"
                  *ngIf="patient.patient_number || patient.contact_number"
                >
                  <span
                    class="rx-search-result__detail"
                    *ngIf="patient.patient_number"
                  >
                    <i class="pi pi-id-card" aria-hidden="true"></i>
                    {{ patient.patient_number }}
                  </span>
                  <span
                    class="rx-search-result__detail"
                    *ngIf="patient.contact_number"
                  >
                    <i class="pi pi-phone" aria-hidden="true"></i>
                    {{ patient.contact_number }}
                  </span>
                </div>
              </div>
              <i
                class="pi pi-chevron-right rx-search-result__arrow"
                aria-hidden="true"
              ></i>
            </div>
          </ng-template>
        </p-autoComplete>
        <span
          class="rx-header-search__status"
          *ngIf="isSearchingPatients"
          aria-live="polite"
        >
          <i class="pi pi-spin pi-spinner" aria-hidden="true"></i>
        </span>
      </div>
    </div>

    <div class="rx-top-divider" aria-hidden="true"></div>

    <div class="rx-top-context">
      <app-work-context-bar [compact]="true" />
    </div>
  </div>

  <div class="row" style="height: 100%; overflow: hidden">
    <p-sidebar
      [(visible)]="isPatientVisible"
      position="left"
      [modal]="true"
      dismissible="true"
      [style]="{ width: '30vw' }"
    >
      <div class="d-flex flex-column w-100 h-100 patient-section">
        <div class="patient-queue-shell">
          <div class="queue-tab-topbar">
            <div class="queue-title-wrap">
              <h6 class="queue-title mb-0">Today's Queue</h6>
              <small class="queue-subtitle">
                <ng-container
                  *ngIf="
                    consultationQueueSearchTerm.trim();
                    else liveQueueDefaultCount
                  "
                >
                  {{ filteredConsultationQueue.length }} match(es)
                </ng-container>
                <ng-template #liveQueueDefaultCount>
                  {{ filteredConsultationQueue.length }} patient(s) shown
                </ng-template>
              </small>
            </div>
            <span class="queue-auto-pill">
              <i class="pi pi-sync"></i>
              Auto refresh
            </span>
          </div>

          <div class="queue-search-wrap">
            <i
              class="pi pi-search queue-search-icon"
              aria-hidden="true"
            ></i>
            <input
              #consultationQueueSearchInput
              type="text"
              class="queue-search-input"
              [(ngModel)]="consultationQueueSearchTerm"
              placeholder="Search name"
              aria-label="Search live queue"
            />
            <button
              *ngIf="consultationQueueSearchTerm"
              type="button"
              class="queue-search-clear"
              (click)="clearConsultationQueueSearch()"
              aria-label="Clear live queue search"
            >
              <i class="pi pi-times" aria-hidden="true"></i>
            </button>
          </div>

          <div class="cross-clinic-alerts" *ngIf="queueAlerts.length > 0">
            <button
              *ngFor="let alert of queueAlerts"
              type="button"
              class="cross-clinic-alert"
              (click)="switchToAlertClinic(alert)"
              [title]="'Switch to ' + alert.clinic_name"
            >
              <span class="cca-icon"><i class="pi pi-bell"></i></span>
              <span class="cca-text">
                <strong>{{ alert.waiting }} waiting</strong> at
                {{ alert.clinic_name }}
              </span>
              <span class="cca-switch"
                >Switch <i class="pi pi-arrow-right"></i
              ></span>
            </button>
          </div>

          <div class="queue-status-filters">
            <button
              type="button"
              class="queue-filter-badge queue-filter-badge--status"
              [class.active]="consultationStatusFilter === 'all'"
              (click)="consultationStatusFilter = 'all'"
            >
              <span>All active</span>
              <span class="queue-filter-count">{{
                consultationStatusCounts.all
              }}</span>
            </button>
            <button
              type="button"
              class="queue-filter-badge queue-filter-badge--status"
              [class.active]="consultationStatusFilter === 'waiting'"
              (click)="consultationStatusFilter = 'waiting'"
            >
              <span>Waiting</span>
              <span class="queue-filter-count">{{
                consultationStatusCounts.waiting
              }}</span>
            </button>
            <button
              type="button"
              class="queue-filter-badge queue-filter-badge--status"
              [class.active]="consultationStatusFilter === 'with_doctor'"
              (click)="consultationStatusFilter = 'with_doctor'"
            >
              <span>With doctor</span>
              <span class="queue-filter-count">{{
                consultationStatusCounts.with_doctor
              }}</span>
            </button>
            <button
              type="button"
              class="queue-filter-badge queue-filter-badge--status"
              [class.active]="consultationStatusFilter === 'paused'"
              (click)="consultationStatusFilter = 'paused'"
            >
              <span>Paused</span>
              <span class="queue-filter-count">{{
                consultationStatusCounts.paused
              }}</span>
            </button>
            <button
              type="button"
              class="queue-filter-badge queue-filter-badge--status"
              [class.active]="consultationStatusFilter === 'done'"
              (click)="consultationStatusFilter = 'done'"
            >
              <span>Done</span>
              <span class="queue-filter-count">{{
                consultationStatusCounts.done
              }}</span>
            </button>
          </div>

          <div class="queue-flow-filters">
            <button
              type="button"
              class="queue-filter-badge"
              [class.active]="consultationFlowFilter === 'all'"
              (click)="consultationFlowFilter = 'all'"
            >
              <span>All</span>
              <span class="queue-filter-count">{{
                consultationFlowCounts.all
              }}</span>
            </button>
            <button
              type="button"
              class="queue-filter-badge"
              [class.active]="consultationFlowFilter === 'medicine'"
              (click)="consultationFlowFilter = 'medicine'"
            >
              <span>Medicine Collection</span>
              <span class="queue-filter-count">{{
                consultationFlowCounts.medicine
              }}</span>
            </button>
            <button
              type="button"
              class="queue-filter-badge"
              [class.active]="consultationFlowFilter === 'normal'"
              (click)="consultationFlowFilter = 'normal'"
            >
              <span>Normal Flow</span>
              <span class="queue-filter-count">{{
                consultationFlowCounts.normal
              }}</span>
            </button>
            <button
              type="button"
              class="queue-filter-badge"
              [class.active]="consultationFlowFilter === 'home_delivery'"
              (click)="consultationFlowFilter = 'home_delivery'"
            >
              <span>Home Delivery</span>
              <span class="queue-filter-count">{{
                consultationFlowCounts.home_delivery
              }}</span>
            </button>
            <button
              type="button"
              class="queue-filter-badge"
              [class.active]="consultationFlowFilter === 'domestic'"
              (click)="consultationFlowFilter = 'domestic'"
            >
              <span>Domestic</span>
              <span class="queue-filter-count">{{
                consultationFlowCounts.domestic
              }}</span>
            </button>
            <button
              type="button"
              class="queue-filter-badge"
              [class.active]="consultationFlowFilter === 'international'"
              (click)="consultationFlowFilter = 'international'"
            >
              <span>International</span>
              <span class="queue-filter-count">{{
                consultationFlowCounts.international
              }}</span>
            </button>
          </div>

          <p-scrollPanel [style]="{ width: '100%', height: '62vh' }">
            <div
              *ngIf="
                filteredConsultationQueue.length > 0;
                else emptyConsultationQueue
              "
              class="patient-queue-list"
            >
              <button
                *ngFor="
                  let item of filteredConsultationQueue;
                  let i = index
                "
                type="button"
                class="patient-queue-card"
                [ngClass]="getColorClass(item.status)"
                [class.is-keyboard-focus]="queueKeyboardIndex === i"
                (click)="selectPatient(item)"
              >
                <span
                  class="queue-intake-note"
                  *ngIf="item.appointment_notes"
                  [title]="getReceptionNoteTooltip(item.appointment_notes, item.medicine_intent)"
                  [attr.aria-label]="'Reception note: ' + getReceptionNoteTooltip(item.appointment_notes, item.medicine_intent)"
                >
                  <span
                    *ngIf="item.medicine_intent"
                    class="medicine-intent-badge"
                    [ngClass]="'medicine-intent-badge--' + item.medicine_intent"
                  >{{ getMedicineIntentShort(item.medicine_intent) }}</span>
                  <i class="pi pi-whatsapp" aria-hidden="true"></i>
                </span>
                <div class="queue-card-top">
                  <span class="queue-patient-name">{{ item.name }}</span>
                  <div class="queue-card-top-badges">
                    <span
                      *ngIf="item.medicine_collection"
                      class="medicine-badge"
                      title="Medicine Collection"
                    >
                      <small>MC</small>
                    </span>
                    <span
                      *ngIf="getDeliveryType(item) as deliveryType"
                      class="delivery-badge"
                      [ngClass]="'delivery-badge--' + deliveryType"
                      [title]="getDeliveryBadgeLabel(item)"
                    >
                      <i
                        class="pi"
                        [ngClass]="getDeliveryBadgeIcon(item)"
                        aria-hidden="true"
                      ></i>
                      <span class="delivery-badge-text">{{
                        getDeliveryBadgeShort(item)
                      }}</span>
                    </span>
                    <span
                      *ngIf="hasKeptBalance(item)"
                      class="balance-badge"
                      [title]="'Patient kept balance ₹' + formatKeptBalance(item)"
                    >
                      Bal ₹{{ formatKeptBalance(item) }}
                    </span>
                  </div>
                </div>

                <div class="queue-card-bottom">
                  <span class="queue-status-chip">{{
                    getQueueStatusLabel(item.status)
                  }}</span>
                  <div class="queue-card-bottom-end">
                    <div class="queue-timing-group">
                      <span class="queue-time-pill">
                        <i class="pi pi-clock"></i>
                        {{ formatDisplayTime(item.time) }}
                      </span>
                      <span
                        *ngIf="shouldShowWaitingBadge(item)"
                        class="waiting-time-pill"
                        [class.waiting-time-pill--urgent]="
                          isWaitingUrgent(item)
                        "
                        title="Waiting since check-in"
                      >
                        <span class="waiting-time-pill__label"
                          >Waiting time</span
                        >
                        <span class="waiting-time-pill__value">{{
                          formatWaitingTime(item)
                        }}</span>
                      </span>
                    </div>
                  </div>
                </div>
              </button>
            </div>
          </p-scrollPanel>

          <ng-template #emptyConsultationQueue>
            <div class="queue-empty-state">
              <i
                class="pi"
                [ngClass]="
                  consultationQueueSearchTerm.trim()
                    ? 'pi-search'
                    : 'pi-inbox'
                "
              ></i>
              <p
                class="mb-0"
                *ngIf="
                  consultationQueueSearchTerm.trim();
                  else noLiveQueueEntries
                "
              >
                No matches for "{{ consultationQueueSearchTerm.trim() }}".
              </p>
              <ng-template #noLiveQueueEntries>
                <p class="mb-0">No patients in queue right now.</p>
              </ng-template>
            </div>
          </ng-template>
        </div>
      </div>
    </p-sidebar>

    <div class="col-md-12 T-prescription">
      <div class="flex-grow-1 overflow-auto prescription-main-scroll">
        <div
          class="rx-tab-strip"
          [class.rx-tab-strip--has-open-now]="openConsultationDock.length > 0"
        >
        <div
          class="rx-open-now rx-open-now--tabstrip"
          *ngIf="openConsultationDock.length > 0"
          aria-label="Open now"
        >
          <span class="rx-open-now__label">Open now</span>
          <div class="rx-open-now__chips">
            <div
              class="rx-open-chip"
              *ngFor="let entry of openConsultationDock; trackBy: trackOpenConsultation"
              [class.is-active]="isActiveOpenConsultation(entry)"
              [class.is-switching]="isSwitchingToOpenConsultation(entry)"
              [class.rx-open-chip--blue]="getOpenChipTone(entry) === 'blue'"
              [class.rx-open-chip--teal]="getOpenChipTone(entry) === 'teal'"
              [class.rx-open-chip--violet]="getOpenChipTone(entry) === 'violet'"
              [class.rx-open-chip--amber]="getOpenChipTone(entry) === 'amber'"
              [class.rx-open-chip--rose]="getOpenChipTone(entry) === 'rose'"
            >
              <button
                type="button"
                class="rx-open-chip__main"
                (click)="switchToOpenConsultation(entry)"
                [attr.aria-busy]="isSwitchingToOpenConsultation(entry) ? true : null"
                [pTooltip]="getOpenChipTooltip(entry)"
                tooltipPosition="bottom"
                [tooltipOptions]="{ showDelay: 400 }"
              >
                <span class="rx-open-chip__avatar" aria-hidden="true">
                  {{ getOpenChipInitials(entry) }}
                </span>
                <span class="rx-open-chip__body">
                  <span class="rx-open-chip__name">{{ getOpenChipName(entry) }}</span>
                  <span class="rx-open-chip__number" *ngIf="getOpenChipNumber(entry)">#{{ getOpenChipNumber(entry) }}</span>
                </span>
                <span
                  class="rx-open-chip__dot"
                  *ngIf="isActiveOpenConsultation(entry) && hasUnsavedWork"
                  aria-label="Not saved yet"
                ></span>
              </button>
              <button
                type="button"
                class="rx-open-chip__dismiss"
                (click)="dismissOpenConsultation(entry, $event)"
                [attr.aria-label]="'Remove ' + getOpenChipName(entry) + ' from Open now'"
                pTooltip="Remove from Open now"
                tooltipPosition="bottom"
                [tooltipOptions]="{ showDelay: 400 }"
              >
                <i class="pi pi-times" aria-hidden="true"></i>
              </button>
            </div>
          </div>
        </div>
        <p-tabView
          [(activeIndex)]="activeIndex"
          styleClass="prescription-tabview prescription-tabview--dock"
        >
          <p-tabPanel>
            <ng-template pTemplate="header">
              <span class="rx-tab-item">
                <i class="pi pi-id-card rx-tab-icon" aria-hidden="true"></i>
                <span class="rx-tab-text">Patient Card</span>
              </span>
            </ng-template>

            <div class="rx-tab-content">
              <div class="container-fluid">
                <section class="patient-banner">
                  <div class="patient-banner-identity">
                    <span class="pb-avatar" aria-hidden="true">
                      <i class="pi pi-user"></i>
                    </span>
                    <div class="pb-identity-text pb-identity-text--editable">
                      <span class="pb-kicker"
                        >Patient <span class="pb-edit-hint">edit</span></span
                      >
                      <input
                        class="pb-name-input"
                        name="full_name"
                        [(ngModel)]="patient.full_name"
                        placeholder="Patient name"
                        autocomplete="off"
                        title="Click to edit patient name"
                      />
                    </div>
                    <span class="pb-free-tag" *ngIf="patient.is_free"
                      >FREE</span
                    >
                    <span class="rx-unsaved-pill" *ngIf="hasUnsavedWork">
                      <span class="rx-unsaved-pill__dot" aria-hidden="true"></span>
                      Not saved yet
                    </span>
                  </div>

                  <div class="patient-banner-meta">
                    <div
                      class="pb-meta-chip pb-meta-chip--readonly pb-meta-chip--reception-note"
                      *ngIf="hasAppointmentIntakeNote"
                    >
                      <span class="pb-meta-label">Reception Note</span>
                      <div class="pb-reception-note-row">
                        <span
                          *ngIf="appointmentMedicineIntent"
                          class="medicine-intent-badge"
                          [ngClass]="'medicine-intent-badge--' + appointmentMedicineIntent"
                          [title]="getMedicineIntentTitle(appointmentMedicineIntent)"
                        >{{ getMedicineIntentShort(appointmentMedicineIntent) }}</span>
                        <span class="pb-meta-value pb-reception-note-text">{{
                          appointmentIntakeNote
                        }}</span>
                        <button
                          type="button"
                          class="pb-reception-note-copy"
                          (click)="copyAppointmentIntakeNote()"
                          title="Copy reception note"
                        >
                          <i class="pi pi-copy" aria-hidden="true"></i>
                        </button>
                      </div>
                    </div>
                    <div class="pb-meta-chip pb-meta-chip--readonly pb-meta-chip--card-no">
                      <span class="pb-meta-label">Card No.</span>
                      <span class="pb-meta-value">{{
                        patient.card_number || "—"
                      }}</span>
                    </div>
                    <div class="pb-meta-chip pb-meta-chip--readonly pb-meta-chip--patient-no">
                      <span class="pb-meta-label">Patient No.</span>
                      <span class="pb-meta-value pb-meta-value--id">{{
                        patient.patient_number || "—"
                      }}</span>
                    </div>
                    <div class="pb-meta-chip pb-meta-chip--editable pb-meta-chip--age">
                      <span class="pb-meta-label"
                        >Age <span class="pb-edit-hint">edit</span></span
                      >
                      <app-patient-age-fields
                        [compact]="true"
                        [showPreview]="false"
                        [(years)]="patient.age"
                        [(months)]="patient.age_months"
                        [(days)]="patient.age_days"
                      ></app-patient-age-fields>
                    </div>
                    <div class="pb-meta-chip pb-meta-chip--editable pb-meta-chip--contact">
                      <span class="pb-meta-label"
                        >Contact <span class="pb-edit-hint">edit</span></span
                      >
                      <div class="pb-reception-note-row">
                        <input
                          class="pb-meta-input"
                          type="tel"
                          name="banner_contact_number"
                          [(ngModel)]="patient.contact_number"
                          placeholder="Add contact"
                          autocomplete="off"
                          title="Click to edit contact number"
                        />
                        <button
                          type="button"
                          class="pb-reception-note-copy"
                          (click)="copyContactNumber()"
                          [disabled]="!(patient.contact_number || '').trim()"
                          title="Copy contact number"
                        >
                          <i class="pi pi-copy" aria-hidden="true"></i>
                        </button>
                      </div>
                    </div>
                  </div>

                  <div class="patient-banner-stripe">
                    <div
                      class="patient-banner-payments"
                      [class.patient-banner-payments--free]="patient.is_free"
                    >
                      <div
                        class="pb-meta-chip pb-meta-chip--pay pb-meta-chip--readonly pb-meta-chip--card-dues"
                      >
                        <span class="pb-meta-label">Card Dues</span>
                        <div class="pb-pay-input-wrap">
                          <span class="pb-pay-prefix" aria-hidden="true"
                            >₹</span
                          >
                          <input
                            class="pb-meta-input pb-meta-input--pay"
                            id="card_dues"
                            name="card_dues"
                            type="number"
                            [(ngModel)]="prescription.card_dues"
                            readonly
                          />
                        </div>
                      </div>

                      <ng-container *ngIf="!patient.is_free">
                        <div
                          class="pb-meta-chip pb-meta-chip--pay pb-meta-chip--fees"
                        >
                          <span class="pb-meta-label">Fees</span>
                          <div class="pb-pay-input-wrap">
                            <span class="pb-pay-prefix" aria-hidden="true"
                              >₹</span
                            >
                            <input
                              class="pb-meta-input pb-meta-input--pay"
                              id="visit_fees"
                              name="visit_fees"
                              type="number"
                              [(ngModel)]="prescription.visit_fees"
                              min="0"
                              placeholder="—"
                              (ngModelChange)="onBannerVisitFeesChange()"
                            />
                          </div>
                        </div>

                        <div
                          class="pb-meta-chip pb-meta-chip--pay pb-meta-chip--discount"
                          [class.pb-meta-chip--discount-full]="prescription.discount_percent >= 100"
                        >
                          <span class="pb-meta-label">Discount</span>
                          <div class="pb-pay-input-wrap">
                            <input
                              class="pb-meta-input pb-meta-input--pay"
                              id="discount_percent"
                              name="discount_percent"
                              type="number"
                              [(ngModel)]="prescription.discount_percent"
                              min="0"
                              max="100"
                              placeholder="0"
                              (ngModelChange)="onBannerDiscountChange()"
                            />
                            <span class="pb-pay-suffix" aria-hidden="true">%</span>
                          </div>
                        </div>

                        <div
                          class="pb-meta-chip pb-meta-chip--pay pb-meta-chip--cash"
                        >
                          <span class="pb-meta-label">Cash</span>
                          <div class="pb-pay-input-wrap">
                            <span class="pb-pay-prefix" aria-hidden="true"
                              >₹</span
                            >
                            <input
                              class="pb-meta-input pb-meta-input--pay"
                              id="received_cash"
                              name="received_cash"
                              type="number"
                              [(ngModel)]="prescription.received_cash"
                              min="0"
                              placeholder="—"
                              (ngModelChange)="onReceivedAmountChange('received_cash')"
                            />
                          </div>
                        </div>

                        <div
                          class="pb-meta-chip pb-meta-chip--pay pb-meta-chip--online"
                        >
                          <div class="pb-online-head">
                            <span class="pb-meta-label">Online</span>
                            <button
                              type="button"
                              class="pb-pay-online-btn"
                              [class.is-paid]="isOnlineAmountSettled()"
                              [disabled]="onlinePaymentInProgress || !canStartOnlinePayment()"
                              [title]="onlinePaymentTitle()"
                              (click)="initiateOnlinePayment()"
                            >
                              <i
                                class="pi"
                                [ngClass]="
                                  onlinePaymentInProgress
                                    ? 'pi-spin pi-spinner'
                                    : isOnlineAmountSettled()
                                      ? 'pi-check'
                                      : 'pi-credit-card'
                                "
                                aria-hidden="true"
                              ></i>
                              <span>{{
                                onlinePaymentInProgress
                                  ? "Wait"
                                  : isOnlineAmountSettled()
                                    ? "Paid"
                                    : "Pay"
                              }}</span>
                            </button>
                          </div>
                          <div class="pb-pay-input-wrap">
                            <span class="pb-pay-prefix" aria-hidden="true"
                              >₹</span
                            >
                            <input
                              class="pb-meta-input pb-meta-input--pay"
                              id="received_online"
                              name="received_online"
                              type="number"
                              [(ngModel)]="prescription.received_online"
                              min="0"
                              placeholder="—"
                              [disabled]="onlinePaymentInProgress"
                              (ngModelChange)="onReceivedAmountChange('received_online')"
                            />
                          </div>
                        </div>

                        <div
                          class="pb-meta-chip pb-meta-chip--pay pb-meta-chip--readonly pb-meta-chip--dues"
                          [class.pb-meta-chip--dues-outstanding]="(prescription.personal_dues || 0) > 0"
                        >
                          <span class="pb-meta-label">{{ (prescription.personal_dues || 0) > 0 ? 'Balance' : 'Dues' }}</span>
                          <div class="pb-pay-input-wrap">
                            <span class="pb-pay-prefix" aria-hidden="true"
                              >₹</span
                            >
                            <input
                              class="pb-meta-input pb-meta-input--pay"
                              id="personal_dues"
                              name="personal_dues"
                              type="number"
                              [(ngModel)]="prescription.personal_dues"
                              readonly
                            />
                          </div>
                        </div>
                      </ng-container>
                    </div>
                  </div>

                  <div
                    class="patient-banner-members"
                    *ngIf="otherCardMembers.length"
                  >
                    <span class="pb-members-label">On this card</span>
                    <div class="pb-members-list">
                      <button
                        type="button"
                        class="pb-member-chip"
                        *ngFor="let member of otherCardMembers"
                        [title]="'Start consultation for ' + cardMemberLabel(member)"
                        (click)="startCardMemberConsultation(member)"
                      >
                        <span class="pb-member-name">{{ cardMemberLabel(member) }}</span>
                        <span class="pb-member-meta" *ngIf="member.patient_number || cardMemberAge(member)">
                          <span *ngIf="member.patient_number">{{ member.patient_number }}</span>
                          <span *ngIf="cardMemberAge(member)">{{ cardMemberAge(member) }}</span>
                        </span>
                        <span class="pb-member-open">Open</span>
                      </button>
                    </div>
                  </div>

                  <input
                    type="hidden"
                    name="card_number"
                    [(ngModel)]="patient.card_number"
                  />
                  <input
                    type="hidden"
                    name="patient_number"
                    [(ngModel)]="patient.patient_number"
                  />
                </section>

                <!-- <hr style="margin-top: auto" /> -->

                <!-- Consultation fields -->
                <section class="consultation-fields">
                  <!-- Chief Complaints -->
                  <article class="cf-card cf-card--complaints">
                    <header class="cf-header">
                      <div class="cf-title">
                        <span class="cf-icon"
                          ><i class="pi pi-comments"></i
                        ></span>
                        <div>
                          <h6 class="cf-label">Chief Complaints</h6>
                          <span class="cf-hint"
                            >Symptoms &amp; presenting issues</span
                          >
                        </div>
                      </div>
                      <div class="cf-toolbar">
                        <button
                          type="button"
                          class="cf-tool cf-tool--mic"
                          [class.is-recording]="
                            isFieldRecording('chief_complaints')
                          "
                          (click)="startDictation('chief_complaints')"
                          [disabled]="
                            isFieldDictationBlocked('chief_complaints')
                          "
                          title="Start dictation"
                        >
                          <i class="pi pi-microphone"></i>
                        </button>
                        <button
                          type="button"
                          class="cf-tool cf-tool--stop"
                          (click)="stopRecording()"
                          [disabled]="!isFieldRecording('chief_complaints')"
                          title="Stop dictation"
                        >
                          <i class="pi pi-stop"></i>
                        </button>
                        <button
                          type="button"
                          class="cf-tool cf-tool--clear"
                          (click)="clearField('chief_complaints')"
                          [disabled]="isFieldRecording('chief_complaints')"
                          title="Clear field"
                        >
                          <i class="pi pi-trash"></i>
                        </button>
                      </div>
                    </header>

                    <div class="cf-body">
                      <!-- Common condition chips (hidden — keep for later restore)
                      <div class="cf-quick-add">
                        <div class="cf-badge-row">
                          <ng-container
                            *ngFor="let cluster of commonComplaintBadgeClusters"
                          >
                            <button
                              *ngFor="let badge of cluster"
                              type="button"
                              class="cf-badge"
                              [class.active]="
                                isChiefComplaintBadgeActive(badge)
                              "
                              (click)="toggleChiefComplaintBadge(badge)"
                              [disabled]="
                                isFieldDictationBlocked('chief_complaints')
                              "
                              [title]="
                                isChiefComplaintBadgeActive(badge)
                                  ? 'Remove ' + badge
                                  : 'Add ' + badge
                              "
                            >
                              {{ badge }}
                            </button>
                          </ng-container>
                        </div>
                      </div>
                      -->

                      <textarea
                        id="chief_complaints"
                        name="chief_complaints"
                        class="cf-textarea cf-textarea--complaints"
                        rows="3"
                        placeholder="Type or dictate chief complaints…"
                        [(ngModel)]="prescription.chief_complaints"
                        [disabled]="isFieldDictationBlocked('chief_complaints')"
                      ></textarea>
                    </div>
                  </article>

                  <!-- Medicines -->
                  <article class="cf-card cf-card--medicines">
                    <header class="cf-header">
                      <div class="cf-title">
                        <span class="cf-icon"><i class="pi pi-box"></i></span>
                        <div>
                          <h6 class="cf-label">Medicines</h6>
                          <span class="cf-hint"
                            >Remedies, potency &amp; dosage</span
                          >
                        </div>
                      </div>
                      <div
                        class="cf-delivery"
                        role="group"
                        aria-label="Delivery options"
                      >
                        <button
                          type="button"
                          class="cf-delivery-opt cf-delivery-opt--pickup"
                          [class.is-active]="isMedicineCollection"
                          (click)="setMedicineCollection(!isMedicineCollection)"
                          pTooltip="Medicine pickup&#10;Patient collects medicines from the clinic&#10;Shortcut: Alt + P"
                          tooltipPosition="bottom"
                        >
                          <i class="pi pi-box" aria-hidden="true"></i>
                          <span>Pickup</span>
                        </button>
                        <button
                          *ngFor="let option of deliveryTypeOptions"
                          type="button"
                          class="cf-delivery-opt"
                          [ngClass]="'cf-delivery-opt--' + option.value"
                          [class.is-active]="isDeliveryTypeActive(option.value)"
                          (click)="setDeliveryType(option.value)"
                          [pTooltip]="getDeliveryOptionTooltip(option)"
                          tooltipPosition="bottom"
                        >
                          <i class="pi" [ngClass]="option.icon" aria-hidden="true"></i>
                          <span>{{ option.shortLabel }}</span>
                        </button>
                      </div>
                    </header>

                    <div class="cf-body">
                      <textarea
                        name="medicines"
                        class="cf-textarea cf-textarea--medicines"
                        rows="3"
                        placeholder="Prescribed medicines…"
                        [(ngModel)]="prescription.medicines"
                        [disabled]="isFieldDictationBlocked('medicines')"
                      ></textarea>
                    </div>
                  </article>

                  <!-- Important Notes -->
                  <article class="cf-card cf-card--important">
                    <header class="cf-header">
                      <div class="cf-title">
                        <span class="cf-icon"
                          ><i class="pi pi-bookmark"></i
                        ></span>
                        <div>
                          <h6 class="cf-label">Important Notes</h6>
                          <span class="cf-hint"
                            >Persists until overwritten — next visit, reminders</span
                          >
                        </div>
                      </div>
                      <div class="cf-toolbar">
                        <button
                          type="button"
                          class="cf-tool cf-tool--clear"
                          (click)="patient.important_notes = ''"
                          [disabled]="!hasSelectedPatient || isFieldDictationBlocked('important_notes')"
                          title="Clear field"
                        >
                          <i class="pi pi-trash"></i>
                        </button>
                      </div>
                    </header>

                    <div class="cf-body">
                      <textarea
                        id="important_notes"
                        name="important_notes"
                        class="cf-textarea cf-textarea--notes"
                        rows="3"
                        placeholder="e.g. Next visit: continue Sulphur 200, check BP…"
                        [(ngModel)]="patient.important_notes"
                        [disabled]="!hasSelectedPatient || isFieldDictationBlocked('important_notes')"
                      ></textarea>
                    </div>
                  </article>

                  <!-- Notes (beside Past History) -->
                  <article
                    class="cf-card cf-card--notes"
                    [class.cf-card--notes-reception]="receptionNotesHighlightActive"
                  >
                    <header class="cf-header">
                      <div class="cf-title">
                        <span class="cf-icon"
                          ><i class="pi pi-file-edit"></i
                        ></span>
                        <div>
                          <h6 class="cf-label">Notes</h6>
                          <div class="cf-hint-row">
                            <span class="cf-hint"
                              >Advice, follow-up &amp; observations</span
                            >
                            <span
                              class="cf-reception-note-badge"
                              *ngIf="receptionNotesHighlightActive"
                              title="This note was added by reception when booking the appointment"
                            >
                              <i class="pi pi-user" aria-hidden="true"></i>
                              From reception
                            </span>
                          </div>
                        </div>
                      </div>
                      <div class="cf-toolbar">
                        <button
                          type="button"
                          class="cf-tool cf-tool--mic"
                          [class.is-recording]="isFieldRecording('notes')"
                          (click)="startDictation('notes')"
                          [disabled]="isFieldDictationBlocked('notes')"
                          title="Start dictation"
                        >
                          <i class="pi pi-microphone"></i>
                        </button>
                        <button
                          type="button"
                          class="cf-tool cf-tool--stop"
                          (click)="stopRecording()"
                          [disabled]="!isFieldRecording('notes')"
                          title="Stop dictation"
                        >
                          <i class="pi pi-stop"></i>
                        </button>
                        <button
                          type="button"
                          class="cf-tool cf-tool--clear"
                          (click)="clearField('notes')"
                          [disabled]="isFieldRecording('notes')"
                          title="Clear field"
                        >
                          <i class="pi pi-trash"></i>
                        </button>
                      </div>
                    </header>

                    <div class="cf-body">
                      <textarea
                        id="notes"
                        name="notes"
                        class="cf-textarea cf-textarea--notes"
                        [class.cf-textarea--reception-note]="receptionNotesHighlightActive"
                        rows="3"
                        placeholder="Consultation notes…"
                        [(ngModel)]="prescription.notes"
                        (ngModelChange)="onPrescriptionNotesChange($event)"
                        [disabled]="isFieldDictationBlocked('notes')"
                      ></textarea>
                    </div>
                  </article>

                  <!-- Past History (beside Notes) -->
                  <article class="cf-card cf-card--past">
                    <header class="cf-header">
                      <div class="cf-title">
                        <span class="cf-icon"
                          ><i class="pi pi-history"></i
                        ></span>
                        <div>
                          <h6 class="cf-label">Past History of any</h6>
                          <span class="cf-hint"
                            >Previous illnesses, surgeries, allergies</span
                          >
                        </div>
                      </div>
                      <div class="cf-toolbar">
                        <button
                          type="button"
                          class="cf-tool cf-tool--clear"
                          (click)="prescription.past_history = ''"
                          [disabled]="!hasSelectedPatient"
                          title="Clear field"
                        >
                          <i class="pi pi-trash"></i>
                        </button>
                      </div>
                    </header>

                    <div class="cf-body">
                      <textarea
                        id="past_history"
                        name="past_history"
                        class="cf-textarea cf-textarea--notes"
                        rows="3"
                        placeholder="Previous illnesses, surgeries, allergies…"
                        [(ngModel)]="prescription.past_history"
                      ></textarea>
                    </div>
                  </article>
                </section>

                <section class="hx-section">
                  <!-- Past History | Menstrual History accordion (hidden — past history moved above)
                  <article
                    class="hx-panel"
                    [class.hx-panel--open]="hxPanelOpen.past"
                    [class.hx-panel--has-data]="hasHxPastData()"
                  >
                    <button
                      type="button"
                      class="hx-panel-head"
                      (click)="toggleHxPanel('past')"
                      [attr.aria-expanded]="hxPanelOpen.past"
                    >
                      <span
                        class="hx-panel-icon hx-panel-icon--past"
                        [class.hx-panel-icon--filled]="hasHxPastData()"
                      >
                        <i class="pi pi-history"></i>
                      </span>
                      <span class="hx-panel-title-wrap">
                        <span class="hx-panel-title"
                          >Past History | Menstrual History</span
                        >
                        <span class="hx-panel-hint"
                          >Prior conditions &amp; menstrual notes</span
                        >
                      </span>
                      <span
                        class="hx-filled-badge"
                        *ngIf="hasHxPastData() && !hxPanelOpen.past"
                        title="Contains saved data — click to review"
                      >
                        <i class="pi pi-check-circle"></i>
                        Filled
                      </span>
                      <i
                        class="pi hx-panel-chevron"
                        [ngClass]="
                          hxPanelOpen.past ? 'pi-chevron-up' : 'pi-chevron-down'
                        "
                      ></i>
                    </button>
                    <div class="hx-panel-body" *ngIf="hxPanelOpen.past">
                      <div class="hx-field-grid hx-field-grid--2">
                        <div class="hx-field">
                          <label for="past_history">Past History of any</label>
                          <textarea
                            id="past_history"
                            name="past_history"
                            class="hx-textarea"
                            rows="3"
                            placeholder="Previous illnesses, surgeries, allergies…"
                            [(ngModel)]="prescription.past_history"
                          ></textarea>
                        </div>
                        <div class="hx-field">
                          <label for="menstrual_history"
                            >Menstrual History</label
                          >
                          <textarea
                            id="menstrual_history"
                            name="menstrual_history"
                            class="hx-textarea"
                            rows="3"
                            placeholder="Cycle, LMP, menopause…"
                            [(ngModel)]="prescription.menstrual_history"
                          ></textarea>
                        </div>
                      </div>
                    </div>
                  </article>
                  -->

                  <!-- Family History panel (hidden — keep for later restore)
                  <article
                    class="hx-panel"
                    [class.hx-panel--open]="hxPanelOpen.family"
                    [class.hx-panel--has-data]="hasHxFamilyData()"
                  >
                    <button
                      type="button"
                      class="hx-panel-head"
                      (click)="toggleHxPanel('family')"
                      [attr.aria-expanded]="hxPanelOpen.family"
                    >
                      <span
                        class="hx-panel-icon hx-panel-icon--family"
                        [class.hx-panel-icon--filled]="hasHxFamilyData()"
                      >
                        <i class="pi pi-users"></i>
                      </span>
                      <span class="hx-panel-title-wrap">
                        <span class="hx-panel-title">Family History</span>
                        <span class="hx-panel-hint"
                          >Mother, father &amp; other relatives</span
                        >
                      </span>
                      <span
                        class="hx-filled-badge"
                        *ngIf="hasHxFamilyData() && !hxPanelOpen.family"
                        title="Contains saved data — click to review"
                      >
                        <i class="pi pi-check-circle"></i>
                        Filled
                      </span>
                      <i
                        class="pi hx-panel-chevron"
                        [ngClass]="
                          hxPanelOpen.family
                            ? 'pi-chevron-up'
                            : 'pi-chevron-down'
                        "
                      ></i>
                    </button>
                    <div class="hx-panel-body" *ngIf="hxPanelOpen.family">
                      <div class="hx-field-grid hx-field-grid--3">
                        <div class="hx-field">
                          <label for="family_history_mother">Mother</label>
                          <textarea
                            name="family_history_mother"
                            id="family_history_mother"
                            class="hx-textarea"
                            rows="3"
                            [(ngModel)]="prescription.family_history.mother"
                          ></textarea>
                        </div>
                        <div class="hx-field">
                          <label for="family_history_father">Father</label>
                          <textarea
                            name="family_history_father"
                            id="family_history_father"
                            class="hx-textarea"
                            rows="3"
                            [(ngModel)]="prescription.family_history.father"
                          ></textarea>
                        </div>
                        <div class="hx-field">
                          <label for="family_history_other">Other</label>
                          <textarea
                            name="family_history_other"
                            id="family_history_other"
                            class="hx-textarea"
                            rows="3"
                            [(ngModel)]="prescription.family_history.other"
                          ></textarea>
                        </div>
                      </div>
                    </div>
                  </article>
                  -->
                </section>
              </div>
            </div>
          </p-tabPanel>

          <p-tabPanel>
            <ng-template pTemplate="header">
              <span class="rx-tab-item">
                <i class="pi pi-sliders-h rx-tab-icon" aria-hidden="true"></i>
                <span class="rx-tab-text">Other</span>
                <span class="rx-tab-status" *ngIf="hasOtData()">
                  <i class="pi pi-check-circle" aria-hidden="true"></i>
                  {{ otFilledSectionCount }}
                </span>
              </span>
            </ng-template>
            <div class="ot-tab">
              <header class="ot-header">
                <div class="ot-header-text">
                  <h6>Other Findings</h6>
                  <p>
                    General exam, physical features, systemic &amp;
                    constitutional notes
                  </p>
                </div>
              </header>

              <section class="ot-section">
                <article
                  class="ot-panel"
                  [class.ot-panel--open]="otPanelOpen.general"
                  [class.ot-panel--has-data]="hasOtGeneralData()"
                >
                  <button
                    type="button"
                    class="ot-panel-head"
                    (click)="toggleOtPanel('general')"
                    [attr.aria-expanded]="otPanelOpen.general"
                  >
                    <span
                      class="ot-panel-icon ot-panel-icon--general"
                      [class.ot-panel-icon--filled]="hasOtGeneralData()"
                    >
                      <i class="pi pi-user"></i>
                    </span>
                    <span class="ot-panel-title-wrap">
                      <span class="ot-panel-title">General Examination</span>
                      <span class="ot-panel-hint"
                        >Pallor, cyanosis, clubbing, icterus</span
                      >
                    </span>
                    <span
                      class="ot-filled-badge"
                      *ngIf="hasOtGeneralData() && !otPanelOpen.general"
                    >
                      <i class="pi pi-check-circle"></i> Filled
                    </span>
                    <i
                      class="pi ot-panel-chevron"
                      [ngClass]="
                        otPanelOpen.general
                          ? 'pi-chevron-up'
                          : 'pi-chevron-down'
                      "
                    ></i>
                  </button>
                  <div class="ot-panel-body" *ngIf="otPanelOpen.general">
                    <div class="ot-field-grid">
                      <div class="ot-field">
                        <label for="pallor">Pallor</label>
                        <input
                          id="pallor"
                          name="pallor"
                          type="text"
                          class="ot-input"
                          [(ngModel)]="prescription.others.pallor"
                        />
                      </div>
                      <div class="ot-field">
                        <label for="cyanosis">Cyanosis</label>
                        <input
                          id="cyanosis"
                          name="cyanosis"
                          type="text"
                          class="ot-input"
                          [(ngModel)]="prescription.others.cyanosis"
                        />
                      </div>
                      <div class="ot-field">
                        <label for="clubbing">Clubbing</label>
                        <input
                          id="clubbing"
                          name="clubbing"
                          type="text"
                          class="ot-input"
                          [(ngModel)]="prescription.others.clubbing"
                        />
                      </div>
                      <div class="ot-field">
                        <label for="icterus">Icterus</label>
                        <input
                          id="icterus"
                          name="icterus"
                          type="text"
                          class="ot-input"
                          [(ngModel)]="prescription.others.icterus"
                        />
                      </div>
                    </div>
                  </div>
                </article>

                <article
                  class="ot-panel"
                  [class.ot-panel--open]="otPanelOpen.physical"
                  [class.ot-panel--has-data]="hasOtPhysicalData()"
                >
                  <button
                    type="button"
                    class="ot-panel-head"
                    (click)="toggleOtPanel('physical')"
                    [attr.aria-expanded]="otPanelOpen.physical"
                  >
                    <span
                      class="ot-panel-icon ot-panel-icon--physical"
                      [class.ot-panel-icon--filled]="hasOtPhysicalData()"
                    >
                      <i class="pi pi-eye"></i>
                    </span>
                    <span class="ot-panel-title-wrap">
                      <span class="ot-panel-title">Physical Features</span>
                      <span class="ot-panel-hint"
                        >Nail, hair, tongue, spine &amp; skin marks</span
                      >
                    </span>
                    <span
                      class="ot-filled-badge"
                      *ngIf="hasOtPhysicalData() && !otPanelOpen.physical"
                    >
                      <i class="pi pi-check-circle"></i> Filled
                    </span>
                    <i
                      class="pi ot-panel-chevron"
                      [ngClass]="
                        otPanelOpen.physical
                          ? 'pi-chevron-up'
                          : 'pi-chevron-down'
                      "
                    ></i>
                  </button>
                  <div class="ot-panel-body" *ngIf="otPanelOpen.physical">
                    <div class="ot-field-grid">
                      <div class="ot-field">
                        <label for="nail">Nail</label>
                        <input
                          id="nail"
                          name="nail"
                          type="text"
                          class="ot-input"
                          [(ngModel)]="prescription.others.nail"
                        />
                      </div>
                      <div class="ot-field">
                        <label for="hair">Hair</label>
                        <input
                          id="hair"
                          name="hair"
                          type="text"
                          class="ot-input"
                          [(ngModel)]="prescription.others.hair"
                        />
                      </div>
                      <div class="ot-field">
                        <label for="tongue">Tongue</label>
                        <input
                          id="tongue"
                          name="tongue"
                          type="text"
                          class="ot-input"
                          [(ngModel)]="prescription.others.tongue"
                        />
                      </div>
                      <div class="ot-field">
                        <label for="spine">Spine</label>
                        <input
                          id="spine"
                          name="spine"
                          type="text"
                          class="ot-input"
                          [(ngModel)]="prescription.others.spine"
                        />
                      </div>
                      <div class="ot-field">
                        <label for="corn">Corn</label>
                        <input
                          id="corn"
                          name="corn"
                          type="text"
                          class="ot-input"
                          [(ngModel)]="prescription.others.corn"
                        />
                      </div>
                      <div class="ot-field">
                        <label for="mole">Mole</label>
                        <input
                          id="mole"
                          name="mole"
                          type="text"
                          class="ot-input"
                          [(ngModel)]="prescription.others.mole"
                        />
                      </div>
                      <div class="ot-field">
                        <label for="warts">Warts</label>
                        <input
                          id="warts"
                          name="warts"
                          type="text"
                          class="ot-input"
                          [(ngModel)]="prescription.others.warts"
                        />
                      </div>
                    </div>
                  </div>
                </article>

                <article
                  class="ot-panel"
                  [class.ot-panel--open]="otPanelOpen.exam"
                  [class.ot-panel--has-data]="hasOtExamData()"
                >
                  <button
                    type="button"
                    class="ot-panel-head"
                    (click)="toggleOtPanel('exam')"
                    [attr.aria-expanded]="otPanelOpen.exam"
                  >
                    <span
                      class="ot-panel-icon ot-panel-icon--exam"
                      [class.ot-panel-icon--filled]="hasOtExamData()"
                    >
                      <i class="pi pi-heart"></i>
                    </span>
                    <span class="ot-panel-title-wrap">
                      <span class="ot-panel-title">RS | CVS | CNS | PA</span>
                      <span class="ot-panel-hint">Systemic examination</span>
                    </span>
                    <span
                      class="ot-filled-badge"
                      *ngIf="hasOtExamData() && !otPanelOpen.exam"
                    >
                      <i class="pi pi-check-circle"></i> Filled
                    </span>
                    <i
                      class="pi ot-panel-chevron"
                      [ngClass]="
                        otPanelOpen.exam ? 'pi-chevron-up' : 'pi-chevron-down'
                      "
                    ></i>
                  </button>
                  <div class="ot-panel-body" *ngIf="otPanelOpen.exam">
                    <div class="ot-field-grid">
                      <div class="ot-field">
                        <label for="respiratory_system">R/S</label>
                        <textarea
                          id="respiratory_system"
                          name="respiratory_system"
                          class="ot-input ot-input--area"
                          rows="3"
                          [(ngModel)]="prescription.respiratory_system"
                        ></textarea>
                      </div>
                      <div class="ot-field">
                        <label for="cardiovascular_system">CVS</label>
                        <textarea
                          id="cardiovascular_system"
                          name="cardiovascular_system"
                          class="ot-input ot-input--area"
                          rows="3"
                          [(ngModel)]="prescription.cardiovascular_system"
                        ></textarea>
                      </div>
                      <div class="ot-field">
                        <label for="central_nervous_system">CNS</label>
                        <textarea
                          id="central_nervous_system"
                          name="central_nervous_system"
                          class="ot-input ot-input--area"
                          rows="3"
                          [(ngModel)]="prescription.central_nervous_system"
                        ></textarea>
                      </div>
                      <div class="ot-field">
                        <label for="per_abdomen">P/A</label>
                        <textarea
                          id="per_abdomen"
                          name="per_abdomen"
                          class="ot-input ot-input--area"
                          rows="3"
                          [(ngModel)]="prescription.per_abdomen"
                        ></textarea>
                      </div>
                    </div>
                  </div>
                </article>

                <article
                  class="ot-panel"
                  [class.ot-panel--open]="otPanelOpen.systemic"
                  [class.ot-panel--has-data]="hasOtSystemicData()"
                >
                  <button
                    type="button"
                    class="ot-panel-head"
                    (click)="toggleOtPanel('systemic')"
                    [attr.aria-expanded]="otPanelOpen.systemic"
                  >
                    <span
                      class="ot-panel-icon ot-panel-icon--systemic"
                      [class.ot-panel-icon--filled]="hasOtSystemicData()"
                    >
                      <i class="pi pi-sync"></i>
                    </span>
                    <span class="ot-panel-title-wrap">
                      <span class="ot-panel-title">Systemic Functions</span>
                      <span class="ot-panel-hint"
                        >Stool, urine, sleep &amp; perspiration</span
                      >
                    </span>
                    <span
                      class="ot-filled-badge"
                      *ngIf="hasOtSystemicData() && !otPanelOpen.systemic"
                    >
                      <i class="pi pi-check-circle"></i> Filled
                    </span>
                    <i
                      class="pi ot-panel-chevron"
                      [ngClass]="
                        otPanelOpen.systemic
                          ? 'pi-chevron-up'
                          : 'pi-chevron-down'
                      "
                    ></i>
                  </button>
                  <div class="ot-panel-body" *ngIf="otPanelOpen.systemic">
                    <div class="ot-field-grid">
                      <div class="ot-field">
                        <label for="stool">Stool</label>
                        <input
                          id="stool"
                          name="stool"
                          type="text"
                          class="ot-input"
                          [(ngModel)]="prescription.others.stool"
                        />
                      </div>
                      <div class="ot-field">
                        <label for="urine">Urine</label>
                        <input
                          id="urine"
                          name="urine"
                          type="text"
                          class="ot-input"
                          [(ngModel)]="prescription.others.urine"
                        />
                      </div>
                      <div class="ot-field">
                        <label for="sleep">Sleep</label>
                        <input
                          id="sleep"
                          name="sleep"
                          type="text"
                          class="ot-input"
                          [(ngModel)]="prescription.others.sleep"
                        />
                      </div>
                      <div class="ot-field">
                        <label for="parsp">Parsp</label>
                        <input
                          id="parsp"
                          name="parsp"
                          type="text"
                          class="ot-input"
                          [(ngModel)]="prescription.others.parsp"
                        />
                      </div>
                    </div>
                  </div>
                </article>

                <article
                  class="ot-panel"
                  [class.ot-panel--open]="otPanelOpen.constitutional"
                  [class.ot-panel--has-data]="hasOtConstitutionalData()"
                >
                  <button
                    type="button"
                    class="ot-panel-head"
                    (click)="toggleOtPanel('constitutional')"
                    [attr.aria-expanded]="otPanelOpen.constitutional"
                  >
                    <span
                      class="ot-panel-icon ot-panel-icon--constitutional"
                      [class.ot-panel-icon--filled]="hasOtConstitutionalData()"
                    >
                      <i class="pi pi-sun"></i>
                    </span>
                    <span class="ot-panel-title-wrap">
                      <span class="ot-panel-title"
                        >Constitutional Symptoms</span
                      >
                      <span class="ot-panel-hint"
                        >Thirst, craving, aversion &amp; thermals</span
                      >
                    </span>
                    <span
                      class="ot-filled-badge"
                      *ngIf="
                        hasOtConstitutionalData() && !otPanelOpen.constitutional
                      "
                    >
                      <i class="pi pi-check-circle"></i> Filled
                    </span>
                    <i
                      class="pi ot-panel-chevron"
                      [ngClass]="
                        otPanelOpen.constitutional
                          ? 'pi-chevron-up'
                          : 'pi-chevron-down'
                      "
                    ></i>
                  </button>
                  <div class="ot-panel-body" *ngIf="otPanelOpen.constitutional">
                    <div class="ot-field-grid">
                      <div class="ot-field">
                        <label for="thirst">Thirst</label>
                        <input
                          id="thirst"
                          name="thirst"
                          type="text"
                          class="ot-input"
                          [(ngModel)]="prescription.others.thirst"
                        />
                      </div>
                      <div class="ot-field">
                        <label for="craving">Craving</label>
                        <input
                          id="craving"
                          name="craving"
                          type="text"
                          class="ot-input"
                          [(ngModel)]="prescription.others.craving"
                        />
                      </div>
                      <div class="ot-field">
                        <label for="aversion">Aversion</label>
                        <input
                          id="aversion"
                          name="aversion"
                          type="text"
                          class="ot-input"
                          [(ngModel)]="prescription.others.aversion"
                        />
                      </div>
                      <div class="ot-field">
                        <label for="thermals">Thermals</label>
                        <input
                          id="thermals"
                          name="thermals"
                          type="text"
                          class="ot-input"
                          [(ngModel)]="prescription.others.thermals"
                        />
                      </div>
                    </div>
                  </div>
                </article>

                <article
                  class="ot-panel"
                  [class.ot-panel--open]="otPanelOpen.mental"
                  [class.ot-panel--has-data]="hasOtMentalData()"
                >
                  <button
                    type="button"
                    class="ot-panel-head"
                    (click)="toggleOtPanel('mental')"
                    [attr.aria-expanded]="otPanelOpen.mental"
                  >
                    <span
                      class="ot-panel-icon ot-panel-icon--mental"
                      [class.ot-panel-icon--filled]="hasOtMentalData()"
                    >
                      <i class="pi pi-bolt"></i>
                    </span>
                    <span class="ot-panel-title-wrap">
                      <span class="ot-panel-title"
                        >Mental &amp; Miscellaneous</span
                      >
                      <span class="ot-panel-hint"
                        >Mentals, dreams &amp; L.M.</span
                      >
                    </span>
                    <span
                      class="ot-filled-badge"
                      *ngIf="hasOtMentalData() && !otPanelOpen.mental"
                    >
                      <i class="pi pi-check-circle"></i> Filled
                    </span>
                    <i
                      class="pi ot-panel-chevron"
                      [ngClass]="
                        otPanelOpen.mental ? 'pi-chevron-up' : 'pi-chevron-down'
                      "
                    ></i>
                  </button>
                  <div class="ot-panel-body" *ngIf="otPanelOpen.mental">
                    <div class="ot-field-grid ot-field-grid--3">
                      <div class="ot-field">
                        <label for="mentals">Mentals</label>
                        <input
                          id="mentals"
                          name="mentals"
                          type="text"
                          class="ot-input"
                          [(ngModel)]="prescription.others.mentals"
                        />
                      </div>
                      <div class="ot-field">
                        <label for="dreams">Dreams</label>
                        <input
                          id="dreams"
                          name="dreams"
                          type="text"
                          class="ot-input"
                          [(ngModel)]="prescription.others.dreams"
                        />
                      </div>
                      <div class="ot-field">
                        <label for="lm">L.M.</label>
                        <input
                          id="lm"
                          name="lm"
                          type="text"
                          class="ot-input"
                          [(ngModel)]="prescription.others.lm"
                        />
                      </div>
                    </div>
                  </div>
                </article>
              </section>
            </div>
          </p-tabPanel>

          <!-- reports -->
          <p-tabPanel>
            <ng-template pTemplate="header">
              <span class="rx-tab-item">
                <i class="pi pi-paperclip rx-tab-icon" aria-hidden="true"></i>
                <span class="rx-tab-text">Reports</span>
                <span class="rx-tab-status" *ngIf="totalReportsCount > 0">
                  <i class="pi pi-file" aria-hidden="true"></i>
                  {{ totalReportsCount }}
                </span>
              </span>
            </ng-template>

            <div class="rd">
              <!-- Drop zone -->
              <div
                class="rd-drop"
                [class.rd-drop--over]="reportsDropActive"
                (click)="triggerDocUpload()"
                (dragover)="onReportsDragOver($event)"
                (dragleave)="onReportsDragLeave($event)"
                (drop)="onReportsDrop($event)"
              >
                <input
                  #docUploadInput
                  type="file"
                  class="rd-drop__input"
                  multiple
                  (change)="onFileSelect($event)"
                  accept="application/pdf,image/png,image/jpeg"
                />
                <div class="rd-drop__icon-wrap">
                  <i class="pi pi-cloud-upload"></i>
                </div>
                <div class="rd-drop__body">
                  <p class="rd-drop__title">Drop files here or click to browse</p>
                  <p class="rd-drop__subtitle">
                    <i class="pi pi-arrows-alt"></i>
                    Drag &amp; drop lab reports, scans, or photos from your computer
                  </p>
                  <div class="rd-drop__badges">
                    <span class="rd-drop__badge rd-drop__badge--pdf"><i class="pi pi-file-pdf"></i> PDF</span>
                    <span class="rd-drop__badge rd-drop__badge--jpg"><i class="pi pi-image"></i> JPG</span>
                    <span class="rd-drop__badge rd-drop__badge--png"><i class="pi pi-image"></i> PNG</span>
                    <span class="rd-drop__badge rd-drop__badge--size"><i class="pi pi-database"></i> Max 20 MB each</span>
                  </div>
                </div>
                <button type="button" class="rd-drop__browse" (click)="triggerDocUpload(); $event.stopPropagation()">
                  <i class="pi pi-folder-open"></i>
                  Browse files
                </button>
              </div>

              <!-- Pending upload queue -->
              <div class="rd-pending" *ngIf="pendingFiles.length">
                <div class="rd-pending__files">
                  <span class="rd-pending__chip" *ngFor="let pf of pendingFiles; let i = index">
                    <i class="pi" [ngClass]="getPendingFileIcon(pf)"></i>
                    <span class="rd-pending__name">{{ pf.name }}</span>
                    <span class="rd-pending__size">{{ formatFileSize(pf.size) }}</span>
                    <button type="button" class="rd-pending__x" (click)="removePendingFile(i, $event)"><i class="pi pi-times"></i></button>
                  </span>
                </div>
                <div class="rd-pending__actions">
                  <button type="button" class="rd-btn rd-btn--ghost" (click)="resetSelectedFiles()">Clear</button>
                  <button
                    type="button"
                    class="rd-btn rd-btn--accent"
                    [disabled]="isUploadingReports"
                    (click)="onUploadSelectedFiles(); $event.stopPropagation()"
                  >
                    <i class="pi" [ngClass]="isUploadingReports ? 'pi-spin pi-spinner' : 'pi-upload'"></i>
                    Upload
                  </button>
                </div>
              </div>

              <!-- Document cards -->
              <ng-container *ngIf="reportRows.length; else rdEmpty">
                <div class="rd-grid">
                  <div class="rd-grid__head">
                    <span class="rd-grid__head-title">
                      <i class="pi pi-folder-open"></i>
                      {{ totalReportsCount }} document{{ totalReportsCount === 1 ? '' : 's' }}
                    </span>
                    <span class="rd-grid__head-meta" *ngIf="reportsPdfCount || reportsImageCount">
                      <span *ngIf="reportsPdfCount" class="rd-grid__head-chip rd-grid__head-chip--pdf">{{ reportsPdfCount }} PDF</span>
                      <span *ngIf="reportsImageCount" class="rd-grid__head-chip rd-grid__head-chip--image">{{ reportsImageCount }} image{{ reportsImageCount === 1 ? '' : 's' }}</span>
                    </span>
                  </div>
                  <div class="rd-grid__cards">
                    <article
                      *ngFor="let row of reportRows; trackBy: trackReportRow"
                      class="rd-card"
                      [ngClass]="getReportFileIconClass(row.file)"
                      role="button"
                      tabindex="0"
                      [class.rd-card--loading]="openingReportId === row.file.id"
                      (click)="openFile(row.file, $event)"
                      (keydown.enter)="openFile(row.file, $event)"
                    >
                      <div class="rd-card__top">
                        <span class="rd-card__icon">
                          <i class="pi" [ngClass]="getReportFileIcon(row.file)"></i>
                        </span>
                        <span class="rd-card__type">{{ getReportTypeLabel(row.file) }}</span>
                      </div>
                      <h4 class="rd-card__name" [title]="row.file.name">{{ row.file.name }}</h4>
                      <p class="rd-card__date">
                        <i class="pi pi-calendar"></i>
                        {{ row.date | date: "dd MMM yyyy" }}
                      </p>
                      <div class="rd-card__actions">
                        <button type="button" class="rd-card__btn rd-card__btn--view" (click)="openFile(row.file, $event)" title="View">
                          <i class="pi" [ngClass]="openingReportId === row.file.id ? 'pi-spin pi-spinner' : 'pi-eye'"></i>
                        </button>
                        <button type="button" class="rd-card__btn rd-card__btn--download" (click)="downloadReport(row.file, $event)" title="Download">
                          <i class="pi pi-download"></i>
                        </button>
                        <button
                          type="button"
                          class="rd-card__btn rd-card__btn--danger"
                          [disabled]="deletingReportId === row.file.id"
                          (click)="deleteReport(row.file, $event)"
                          title="Delete"
                        >
                          <i class="pi" [ngClass]="deletingReportId === row.file.id ? 'pi-spin pi-spinner' : 'pi-trash'"></i>
                        </button>
                      </div>
                    </article>
                  </div>
                </div>
              </ng-container>

              <ng-template #rdEmpty>
                <div class="rd-empty">
                  <span>No reports yet</span>
                </div>
              </ng-template>
            </div>
          </p-tabPanel>

          <!-- records -->
          <p-tabPanel>
            <ng-template pTemplate="header">
              <span class="rx-tab-item">
                <i class="pi pi-history rx-tab-icon" aria-hidden="true"></i>
                <span class="rx-tab-text">History</span>
                <span class="rx-tab-status" *ngIf="filteredRecords.length > 0">
                  <i class="pi pi-calendar" aria-hidden="true"></i>
                  {{ filteredRecords.length }}
                </span>
              </span>
            </ng-template>

            <div class="history-tab">
              <ng-container
                *ngIf="filteredRecords.length > 0; else noRecordsTemplate"
              >
                <div class="history-sheet">
                  <header class="history-sheet-toolbar">
                    <div class="history-sheet-meta">
                      <strong>Visit sheet</strong>
                      <span>{{ historySheetRangeLabel }}</span>
                      <span class="history-correct-hint">Click any visit to correct it</span>
                    </div>
                    <div class="history-sheet-pager" *ngIf="historySheetPageCount > 1">
                      <button
                        type="button"
                        class="history-sheet-nav"
                        (click)="prevHistorySheetPage()"
                        [disabled]="historySheetPage === 0"
                        title="Previous 20 visits"
                      >
                        <i class="pi pi-chevron-left"></i>
                      </button>
                      <span class="history-sheet-page">
                        {{ historySheetPage + 1 }} / {{ historySheetPageCount }}
                      </span>
                      <button
                        type="button"
                        class="history-sheet-nav"
                        (click)="nextHistorySheetPage()"
                        [disabled]="historySheetPage >= historySheetPageCount - 1"
                        title="Next 20 visits"
                      >
                        <i class="pi pi-chevron-right"></i>
                      </button>
                    </div>
                  </header>

                  <div
                    class="history-important-note"
                    *ngIf="(patient.important_notes || '').trim()"
                    [title]="patient.important_notes"
                  >
                    <span class="history-important-note__label">
                      <i class="pi pi-bookmark" aria-hidden="true"></i>
                      Important
                    </span>
                    <span class="history-important-note__text">{{
                      patient.important_notes
                    }}</span>
                  </div>

                  <div class="history-sheet-grid">
                    <div class="history-sheet-col">
                      <table class="history-sheet-table" (click)="onHistorySheetClick($event)">
                        <thead>
                          <tr>
                            <th class="col-no">#</th>
                            <th class="col-date">Date</th>
                            <th class="col-edit"></th>
                            <th class="col-complaints">Complaints</th>
                            <th class="col-medicines">Medicines</th>
                            <th class="col-notes">Notes</th>
                            <th class="col-pay">Pay</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr
                            *ngFor="let row of historyLeftColumn; trackBy: trackHistoryRow"
                            class="is-clickable"
                            [class.is-latest]="row.index === 0"
                            [attr.data-history-index]="row.index"
                            (click)="openVisitRevision(row.record, $event)"
                          >
                            <td class="col-no">{{ row.index + 1 }}</td>
                            <td class="col-date">
                              <span class="hs-date">{{
                                getRecordDisplayDate(row.record) | date: "dd MMM yy"
                              }}</span>
                              <span class="hs-latest" *ngIf="row.index === 0">L</span>
                              <span class="hs-version" *ngIf="revisionCount(row.record) > 1">v{{ revisionCount(row.record) }}</span>
                            </td>
                            <td class="col-edit">
                              <button
                                type="button"
                                class="hs-revise"
                                [title]="'Correct ' + (getRecordDisplayDate(row.record) | date: 'dd MMM yyyy')"
                                (click)="openVisitRevision(row.record, $event)"
                              >
                                <i class="pi pi-pencil"></i>
                              </button>
                            </td>
                            <td
                              class="col-complaints"
                              [class.is-empty]="isHistoryEmpty(row.record.chief_complaints)"
                              [class.is-revisable]="true"
                              [title]="formatHistoryText(row.record.chief_complaints)"
                            >
                              <span class="hs-cell">{{
                                formatHistoryText(row.record.chief_complaints)
                              }}</span>
                            </td>
                            <td
                              class="col-medicines"
                              [class.is-empty]="isHistoryEmpty(row.record.medicines)"
                              [class.is-revisable]="true"
                              [title]="formatHistoryText(row.record.medicines)"
                            >
                              <span class="hs-cell">{{
                                formatHistoryText(row.record.medicines)
                              }}</span>
                            </td>
                            <td
                              class="col-notes"
                              [class.is-empty]="isHistoryEmpty(row.record.notes)"
                              [class.is-revisable]="true"
                              [title]="formatHistoryText(row.record.notes)"
                            >
                              <span class="hs-cell">{{
                                formatHistoryText(row.record.notes)
                              }}</span>
                            </td>
                            <td
                              class="col-pay"
                              [class.is-empty]="!hasHistoryPaymentInfo(row.record)"
                              [title]="formatHistoryPaymentSummary(row.record)"
                            >
                              <div class="hs-pay" *ngIf="hasHistoryPaymentInfo(row.record); else emptySheetPay">
                                <span
                                  class="hs-pay-chip"
                                  *ngFor="let item of getHistoryPaymentItems(row.record)"
                                  [ngClass]="'hs-pay-chip--' + item.key"
                                >
                                  {{
                                    item.key === 'discount'
                                      ? item.amount + '%'
                                      : getHistoryPaymentShortCode(item.key) + item.amount
                                  }}
                                </span>
                              </div>
                            </td>
                          </tr>
                          <tr
                            *ngFor="let _ of historyPadRows(historyLeftColumn.length)"
                            class="is-pad"
                          >
                            <td class="col-no"></td>
                            <td class="col-date"></td>
                            <td class="col-edit"></td>
                            <td class="col-complaints"></td>
                            <td class="col-medicines"></td>
                            <td class="col-notes"></td>
                            <td class="col-pay"></td>
                          </tr>
                        </tbody>
                      </table>
                      <ng-template #emptySheetPay>
                        <span class="hs-empty-pay">—</span>
                      </ng-template>
                    </div>

                    <div class="history-sheet-col">
                      <table class="history-sheet-table" (click)="onHistorySheetClick($event)">
                        <thead>
                          <tr>
                            <th class="col-no">#</th>
                            <th class="col-date">Date</th>
                            <th class="col-edit"></th>
                            <th class="col-complaints">Complaints</th>
                            <th class="col-medicines">Medicines</th>
                            <th class="col-notes">Notes</th>
                            <th class="col-pay">Pay</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr
                            *ngFor="let row of historyRightColumn; trackBy: trackHistoryRow"
                            class="is-clickable"
                            [class.is-latest]="row.index === 0"
                            [attr.data-history-index]="row.index"
                            (click)="openVisitRevision(row.record, $event)"
                          >
                            <td class="col-no">{{ row.index + 1 }}</td>
                            <td class="col-date">
                              <span class="hs-date">{{
                                getRecordDisplayDate(row.record) | date: "dd MMM yy"
                              }}</span>
                              <span class="hs-latest" *ngIf="row.index === 0">L</span>
                              <span class="hs-version" *ngIf="revisionCount(row.record) > 1">v{{ revisionCount(row.record) }}</span>
                            </td>
                            <td class="col-edit">
                              <button
                                type="button"
                                class="hs-revise"
                                [title]="'Correct ' + (getRecordDisplayDate(row.record) | date: 'dd MMM yyyy')"
                                (click)="openVisitRevision(row.record, $event)"
                              >
                                <i class="pi pi-pencil"></i>
                              </button>
                            </td>
                            <td
                              class="col-complaints"
                              [class.is-empty]="isHistoryEmpty(row.record.chief_complaints)"
                              [class.is-revisable]="true"
                              [title]="formatHistoryText(row.record.chief_complaints)"
                            >
                              <span class="hs-cell">{{
                                formatHistoryText(row.record.chief_complaints)
                              }}</span>
                            </td>
                            <td
                              class="col-medicines"
                              [class.is-empty]="isHistoryEmpty(row.record.medicines)"
                              [class.is-revisable]="true"
                              [title]="formatHistoryText(row.record.medicines)"
                            >
                              <span class="hs-cell">{{
                                formatHistoryText(row.record.medicines)
                              }}</span>
                            </td>
                            <td
                              class="col-notes"
                              [class.is-empty]="isHistoryEmpty(row.record.notes)"
                              [class.is-revisable]="true"
                              [title]="formatHistoryText(row.record.notes)"
                            >
                              <span class="hs-cell">{{
                                formatHistoryText(row.record.notes)
                              }}</span>
                            </td>
                            <td
                              class="col-pay"
                              [class.is-empty]="!hasHistoryPaymentInfo(row.record)"
                              [title]="formatHistoryPaymentSummary(row.record)"
                            >
                              <div class="hs-pay" *ngIf="hasHistoryPaymentInfo(row.record); else emptySheetPayRight">
                                <span
                                  class="hs-pay-chip"
                                  *ngFor="let item of getHistoryPaymentItems(row.record)"
                                  [ngClass]="'hs-pay-chip--' + item.key"
                                >
                                  {{
                                    item.key === 'discount'
                                      ? item.amount + '%'
                                      : getHistoryPaymentShortCode(item.key) + item.amount
                                  }}
                                </span>
                              </div>
                            </td>
                          </tr>
                          <tr
                            *ngFor="let _ of historyPadRows(historyRightColumn.length)"
                            class="is-pad"
                          >
                            <td class="col-no"></td>
                            <td class="col-date"></td>
                            <td class="col-edit"></td>
                            <td class="col-complaints"></td>
                            <td class="col-medicines"></td>
                            <td class="col-notes"></td>
                            <td class="col-pay"></td>
                          </tr>
                        </tbody>
                      </table>
                      <ng-template #emptySheetPayRight>
                        <span class="hs-empty-pay">—</span>
                      </ng-template>
                    </div>
                  </div>
                </div>
              </ng-container>

              <ng-template #noRecordsTemplate>
                <div class="history-empty">
                  <div class="history-empty-icon">
                    <i class="pi pi-inbox"></i>
                  </div>
                  <h6>No visit history yet</h6>
                  <p>
                    Select a patient to view their past prescriptions and
                    consultation records.
                  </p>
                </div>
              </ng-template>

              <section class="rx-pay-ledger" *ngIf="hasSelectedPatient">
                <header class="rx-pay-ledger__bar">
                  <strong>Payments</strong>
                  <span *ngIf="patientPayments && !patientPaymentsLoading">
                    {{ patientPayments.visits }} visits
                    · Fees ₹{{ paymentAmount(patientPayments.fees) }}
                    · Collected ₹{{ paymentAmount(patientPayments.collected) }}
                    · Balance ₹{{ paymentAmount(patientPayments.outstanding) }}
                  </span>
                  <span *ngIf="patientPaymentsLoading">Loading payments…</span>
                </header>
                <div class="pay-ledger" *ngIf="patientPayments?.lines?.length">
                  <table>
                    <thead>
                      <tr>
                        <th>Date</th>
                        <th>Type</th>
                        <th>Discount</th>
                        <th class="text-end">Fee</th>
                        <th class="text-end">Cash</th>
                        <th class="text-end">Online</th>
                        <th class="text-end">Collected</th>
                        <th>Result</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngFor="let line of patientPayments.lines" [ngClass]="paymentLineTone(line)">
                        <td>{{ paymentLineDate(line.date) }}</td>
                        <td>{{ line.kind === 'dues' ? 'Dues' : 'Visit' }}</td>
                        <td>
                          <span
                            class="pay-off"
                            [class.is-full]="line.discount_percent >= 100"
                            [class.is-none]="!(line.discount_percent > 0)"
                            [attr.title]="line.discount_percent > 0 ? line.discount_percent + '% discount on the visit fee' : 'No discount on this visit'"
                          >{{ line.discount_percent >= 100 ? line.discount_percent + '% Free' : (line.discount_percent > 0 ? line.discount_percent + '%' : 'No discount') }}</span>
                        </td>
                        <td class="text-end mono">{{ line.kind === 'visit' ? '₹' + paymentAmount(line.fees) : '—' }}</td>
                        <td class="text-end mono" [class.amount-cash]="line.cash > 0">{{ line.cash > 0 ? '₹' + paymentAmount(line.cash) : '—' }}</td>
                        <td class="text-end mono" [class.amount-online]="line.online > 0">{{ line.online > 0 ? '₹' + paymentAmount(line.online) : '—' }}</td>
                        <td class="text-end mono">₹{{ paymentAmount(line.collected) }}</td>
                        <td>
                          <span class="pay-result" [attr.title]="paymentLineNote(line)">{{ paymentLineResult(line) }}</span>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <p class="rx-pay-ledger__empty" *ngIf="patientPaymentsError">
                  Payments could not be loaded.
                </p>
                <p class="rx-pay-ledger__empty" *ngIf="!patientPaymentsLoading && !patientPaymentsError && !patientPayments?.lines?.length">
                  No payments recorded for this patient.
                </p>
              </section>
            </div>
          </p-tabPanel>
        </p-tabView>
        </div>

        <!-- Fixed footer -->
        <div class="footer-buttons">
          <div class="footer-bar">
            <button
              type="button"
              class="footer-save-btn"
              (click)="addPrescriptions()"
              [disabled]="!isFormValid()"
            >
              <span class="footer-save-icon" aria-hidden="true">
                <i class="pi pi-check"></i>
              </span>
              <span class="footer-save-label">Save Changes</span>
            </button>
          </div>
        </div>
      </div>
    </div>

    <p-sidebar
      [(visible)]="isMedicineVisible"
      position="right"
      [modal]="true"
      dismissible="true"
      [style]="{ width: '30vw' }"
      styleClass="medicine-queue-sidebar"
    >
      <div class="flex-grow-1 p-1 w-100 medicine-queue-wrapper">
        <div class="patient-queue-shell medicine-queue-shell">
          <div class="queue-tab-topbar">
            <div class="queue-title-wrap">
              <h6 class="queue-title mb-0">Medicine Collection Queue</h6>
              <small class="queue-subtitle">
                <ng-container
                  *ngIf="
                    medicineQueueSearchTerm.trim();
                    else mcQueueDefaultCount
                  "
                >
                  {{ filteredMedicineCollectionQueue.length }} match(es)
                </ng-container>
                <ng-template #mcQueueDefaultCount>
                  {{ filteredMedicineCollectionQueue.length }} patient(s) shown
                </ng-template>
              </small>
            </div>
            <span class="queue-auto-pill">
              <i class="pi pi-sync"></i>
              Auto refresh
            </span>
          </div>

          <div class="queue-search-wrap">
            <i class="pi pi-search queue-search-icon" aria-hidden="true"></i>
            <input
              #medicineQueueSearchInput
              type="text"
              class="queue-search-input"
              [(ngModel)]="medicineQueueSearchTerm"
              placeholder="Search name"
              aria-label="Search medicine collection queue"
            />
            <button
              *ngIf="medicineQueueSearchTerm"
              type="button"
              class="queue-search-clear"
              (click)="clearMedicineQueueSearch()"
              aria-label="Clear medicine queue search"
            >
              <i class="pi pi-times" aria-hidden="true"></i>
            </button>
          </div>

          <div class="queue-flow-filters">
            <button
              type="button"
              class="queue-filter-badge"
              [class.active]="medicineQueueFlowFilter === 'all'"
              (click)="medicineQueueFlowFilter = 'all'"
            >
              <span>All</span>
              <span class="queue-filter-count">{{
                medicineQueueFlowCounts.all
              }}</span>
            </button>
            <button
              type="button"
              class="queue-filter-badge"
              [class.active]="medicineQueueFlowFilter === 'medicine'"
              (click)="medicineQueueFlowFilter = 'medicine'"
            >
              <span>Medicine Collection</span>
              <span class="queue-filter-count">{{
                medicineQueueFlowCounts.medicine
              }}</span>
            </button>
            <button
              type="button"
              class="queue-filter-badge"
              [class.active]="medicineQueueFlowFilter === 'normal'"
              (click)="medicineQueueFlowFilter = 'normal'"
            >
              <span>Normal</span>
              <span class="queue-filter-count">{{
                medicineQueueFlowCounts.normal
              }}</span>
            </button>
            <button
              type="button"
              class="queue-filter-badge"
              [class.active]="medicineQueueFlowFilter === 'home_delivery'"
              (click)="medicineQueueFlowFilter = 'home_delivery'"
            >
              <span>Home Delivery</span>
              <span class="queue-filter-count">{{
                medicineQueueFlowCounts.home_delivery
              }}</span>
            </button>
            <button
              type="button"
              class="queue-filter-badge"
              [class.active]="medicineQueueFlowFilter === 'domestic'"
              (click)="medicineQueueFlowFilter = 'domestic'"
            >
              <span>Domestic</span>
              <span class="queue-filter-count">{{
                medicineQueueFlowCounts.domestic
              }}</span>
            </button>
            <button
              type="button"
              class="queue-filter-badge"
              [class.active]="medicineQueueFlowFilter === 'international'"
              (click)="medicineQueueFlowFilter = 'international'"
            >
              <span>International</span>
              <span class="queue-filter-count">{{
                medicineQueueFlowCounts.international
              }}</span>
            </button>
          </div>

          <!-- <p-scrollPanel [style]="{ width: '100%', height: '72vh' }"> -->
          <div
            *ngIf="
              filteredMedicineCollectionQueue.length > 0;
              else emptyMedicineQueue
            "
            class="patient-queue-list medicine-queue-list"
          >
            <div
              *ngFor="
                let item of filteredMedicineCollectionQueue;
                let i = index
              "
              class="patient-queue-card mc-queue-card"
            >
              <div class="queue-card-top">
                <span class="queue-patient-name">{{ item.name }}</span>
                <div class="queue-card-top-badges">
                  <span
                    *ngIf="item.medicine_collection"
                    class="medicine-badge"
                    title="Medicine Collection"
                  >
                    <small>MC</small>
                  </span>
                  <span
                    *ngIf="hasKeptBalance(item)"
                    class="balance-badge"
                    [title]="'Patient kept balance ₹' + formatKeptBalance(item)"
                  >
                    Bal ₹{{ formatKeptBalance(item) }}
                  </span>
                  <button
                    type="button"
                    class="mc-recall-rx-btn"
                    (click)="recallFromMedicineQueue(item, $event)"
                    [attr.aria-label]="'Recall prescription for ' + item.name"
                  >
                    Recall Rx
                  </button>
                </div>
              </div>

              <div class="mc-queue-card-bottom">
                <span class="mc-queue-flow-pill">
                  {{
                    item.medicine_collection
                      ? "Medicine"
                      : getDeliveryBadgeShort(item) || "Normal"
                  }}
                </span>

                <div class="mc-queue-timing-pill">
                  <span class="mc-queue-timing-part">
                    <i class="pi pi-clock" aria-hidden="true"></i>
                    {{ formatDisplayTime(item.time) }}
                  </span>
                  <span class="mc-queue-timing-sep" aria-hidden="true"></span>
                  <span class="mc-queue-timing-part" *ngIf="item.formatdate">
                    <i class="pi pi-calendar" aria-hidden="true"></i>
                    {{ item.formatdate }}
                  </span>
                </div>
              </div>
            </div>
          </div>
          <!-- </p-scrollPanel> -->

          <ng-template #emptyMedicineQueue>
            <div class="queue-empty-state">
              <i
                class="pi"
                [ngClass]="
                  medicineQueueSearchTerm.trim()
                    ? 'pi-search'
                    : 'pi-check-circle'
                "
              ></i>
              <p
                class="mb-0"
                *ngIf="medicineQueueSearchTerm.trim(); else noMcEntries"
              >
                No matches for "{{ medicineQueueSearchTerm.trim() }}".
              </p>
              <ng-template #noMcEntries>
                <p class="mb-0">No medicine queue entries right now.</p>
              </ng-template>
            </div>
          </ng-template>
        </div>
      </div>
    </p-sidebar>
  </div>
</div>

<div
  *ngIf="visitRevisionVisible"
  class="visit-revise-root"
  style="position:fixed;inset:0;z-index:2147483646;display:flex;align-items:center;justify-content:center;padding:16px;background:rgba(15,23,42,0.45)"
  (click)="onVisitReviseBackdrop($event)"
>
  <div
    class="visit-revise__card"
    *ngIf="visitRevisionRecord as record"
    role="dialog"
    aria-modal="true"
    aria-labelledby="visit-revise-title"
    (click)="$event.stopPropagation()"
  >
    <header class="visit-revise__head">
      <div>
        <h2 id="visit-revise-title">Correct this visit</h2>
        <p>
          {{ getRecordDisplayDate(record) | date: "dd MMM yyyy" }}.
          Saving keeps the earlier complaints, medicines, and notes as their own version.
        </p>
      </div>
      <button type="button" class="visit-revise__close" (click)="closeVisitRevision()" [disabled]="visitRevisionSaving" aria-label="Close">
        <i class="pi pi-times"></i>
      </button>
    </header>

    <div class="visit-revise__layout">
      <div class="visit-revise__fields">
        <label>
          <span>Chief complaints</span>
          <textarea rows="4" [(ngModel)]="visitRevisionForm.chief_complaints" [disabled]="visitRevisionSaving"></textarea>
        </label>
        <label>
          <span>Medicines</span>
          <textarea rows="5" [(ngModel)]="visitRevisionForm.medicines" [disabled]="visitRevisionSaving"></textarea>
        </label>
        <label>
          <span>Notes</span>
          <textarea rows="3" [(ngModel)]="visitRevisionForm.notes" [disabled]="visitRevisionSaving"></textarea>
        </label>
      </div>

      <aside class="visit-revise__versions" *ngIf="revisionCount(record) > 0">
        <h3>Versions</h3>
        <button
          type="button"
          class="visit-revise__version"
          *ngFor="let version of record.revisions"
          [class.is-on]="visitRevisionPreview?.version === version.version"
          (click)="previewVisitRevision(version)"
        >
          <strong>v{{ version.version }}</strong>
          <span>{{ version.edited_at | date: "dd MMM yyyy, h:mm a" }}</span>
        </button>
        <div class="visit-revise__preview" *ngIf="visitRevisionPreview as preview">
          <p><strong>Complaints</strong> {{ formatHistoryText(preview.chief_complaints) }}</p>
          <p><strong>Medicines</strong> {{ formatHistoryText(preview.medicines) }}</p>
          <p><strong>Notes</strong> {{ formatHistoryText(preview.notes) }}</p>
          <button type="button" (click)="useVisitRevision(preview)">Use this wording</button>
        </div>
      </aside>
    </div>

    <footer class="visit-revise__actions">
      <button type="button" class="visit-revise__cancel" (click)="closeVisitRevision()" [disabled]="visitRevisionSaving">Cancel</button>
      <button type="button" class="visit-revise__save" (click)="saveVisitRevision()" [disabled]="visitRevisionSaving">
        {{ visitRevisionSaving ? 'Saving…' : 'Save as new version' }}
      </button>
    </footer>
  </div>
</div>

<p-dialog
  [(visible)]="hotkeysHelpVisible"
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
  [dismissableMask]="true"
  [showHeader]="false"
  [baseZIndex]="12000"
  [autoZIndex]="true"
  appendTo="body"
  maskStyleClass="hk-dialog-mask"
  [style]="{ width: '1040px', maxWidth: '96vw' }"
  styleClass="hk-dialog"
>
  <div class="hk-shell">
    <header class="hk-top">
      <div class="hk-top-left">
        <span class="hk-top-icon" aria-hidden="true">
          <i class="pi pi-th-large"></i>
        </span>
        <div class="hk-top-copy">
          <div class="hk-top-title-row">
            <h2 class="hk-top-title">Keyboard Shortcuts</h2>
            <span class="hk-top-count">{{ rxHotkeyCount }} shortcuts</span>
          </div>
          <p class="hk-top-subtitle">Work faster without the mouse</p>
        </div>
      </div>
      <div class="hk-top-right">
        <span class="hk-reopen-pill" aria-hidden="true">
          <span class="hk-reopen-label">Press</span>
          <kbd>Alt</kbd><span class="hk-plus">+</span><kbd>/</kbd>
          <span class="hk-reopen-label">to reopen</span>
        </span>
        <button
          type="button"
          class="hk-top-close"
          (click)="hotkeysHelpVisible = false"
          aria-label="Close shortcuts"
        >
          <i class="pi pi-times"></i>
        </button>
      </div>
    </header>

    <div class="hk-panels">
      <article
        class="hk-panel"
        [ngClass]="'hk-panel--' + section.tone"
        *ngFor="let section of rxHotkeySections"
      >
        <header class="hk-panel-head">
          <span class="hk-panel-icon" aria-hidden="true">
            <i class="pi" [ngClass]="section.icon"></i>
          </span>
          <h3 class="hk-panel-title">{{ section.title }}</h3>
        </header>

        <ul class="hk-panel-list">
          <li class="hk-row" *ngFor="let item of section.items">
            <span class="hk-row-label">{{ item.action }}</span>
            <div class="hk-row-keys">
              <ng-container
                *ngFor="let part of splitHotkeyKeys(item.keys); let last = last"
              >
                <kbd>{{ part }}</kbd>
                <span class="hk-plus" *ngIf="!last">+</span>
              </ng-container>
            </div>
          </li>
        </ul>
      </article>
    </div>
  </div>

  <ng-template pTemplate="footer">
    <div class="hk-footer">
      <span class="hk-footer-note">
        <i class="pi pi-lightbulb" aria-hidden="true"></i>
        Toolbar buttons show their shortcuts on hover while you work.
      </span>
      <button
        type="button"
        class="hk-footer-btn"
        (click)="hotkeysHelpVisible = false"
      >
        Got it
      </button>
    </div>
  </ng-template>
</p-dialog>

<p-dialog
  [(visible)]="commandPaletteVisible"
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
  [dismissableMask]="true"
  [showHeader]="false"
  [style]="{ width: '640px', maxWidth: '96vw' }"
  styleClass="cp-dialog"
  (onHide)="closeCommandPalette()"
>
  <div class="cp-shell">
    <div class="cp-search-row">
      <i class="pi pi-search cp-search-icon" aria-hidden="true"></i>
      <input
        #commandPaletteInput
        type="text"
        class="cp-search-input"
        [(ngModel)]="commandPaletteQuery"
        (ngModelChange)="onCommandPaletteQueryChange()"
        (keydown)="onCommandPaletteKeydown($event)"
        placeholder="Search patients or actions…"
        autocomplete="off"
        spellcheck="false"
        aria-label="Command palette search"
      />
      <kbd class="cp-search-kbd">Esc</kbd>
    </div>

    <div class="cp-results" role="listbox" aria-label="Command palette results">
      <button
        type="button"
        class="cp-item"
        role="option"
        *ngFor="let item of commandPaletteItems; let i = index"
        [class.is-active]="i === commandPaletteIndex"
        (click)="executeCommandPaletteItem(item)"
        (mouseenter)="commandPaletteIndex = i"
      >
        <span class="cp-item-icon" aria-hidden="true">
          <i class="pi" [ngClass]="item.icon || (item.kind === 'patient' ? 'pi-user' : 'pi-bolt')"></i>
        </span>
        <span class="cp-item-copy">
          <span class="cp-item-label">{{ item.label }}</span>
          <span class="cp-item-sublabel" *ngIf="item.sublabel">{{ item.sublabel }}</span>
        </span>
        <span class="cp-item-kind">{{ item.kind === 'action' ? 'Action' : item.kind === 'open' ? 'Open' : 'Patient' }}</span>
      </button>

      <div class="cp-empty" *ngIf="commandPaletteSearching">
        <i class="pi pi-spin pi-spinner" aria-hidden="true"></i>
        <span>Searching patients…</span>
      </div>

      <div class="cp-empty" *ngIf="!commandPaletteSearching && !commandPaletteItems.length">
        <span *ngIf="(commandPaletteQuery || '').trim().length < 2">Type to search patients, or pick an action above.</span>
        <span *ngIf="(commandPaletteQuery || '').trim().length >= 2">No matches found.</span>
      </div>
    </div>

    <footer class="cp-footer">
      <span><kbd>↑</kbd><kbd>↓</kbd> navigate</span>
      <span><kbd>Enter</kbd> select</span>
      <span><kbd>Ctrl</kbd>+<kbd>K</kbd> open</span>
    </footer>
  </div>
</p-dialog>

<p-dialog
  header="Doctor Notes History"
  [(visible)]="notesDialogVisible"
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
  [dismissableMask]="true"
  styleClass="doctor-notes-dialog"
>
  <div class="notes-dialog-body">
    <div *ngIf="notesHistory.length; else notesEmpty" class="notes-list">
      <article *ngFor="let note of notesHistory" class="note-card">
        <div class="note-date">
          {{ getRecordDisplayDate(note) | date: "dd MMM yyyy" }}
        </div>
        <div class="note-text">{{ note.notes }}</div>
      </article>
    </div>
    <ng-template #notesEmpty>
      <div class="notes-empty-state">
        <i class="pi pi-file-edit"></i>
        <p>No doctor notes recorded for this patient yet.</p>
      </div>
    </ng-template>
  </div>
</p-dialog>

<p-dialog
  [(visible)]="quickAddDialogVisible"
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
  [dismissableMask]="true"
  [showHeader]="false"
  [baseZIndex]="1400"
  [autoZIndex]="true"
  styleClass="qa-dialog quick-add-dialog"
  [style]="{ width: '920px', maxWidth: '96vw' }"
>
  <div class="qa-shell">
    <header class="qa-hero">
      <div class="qa-hero-main">
        <span class="qa-hero-icon" aria-hidden="true">
          <i class="pi pi-user-plus"></i>
        </span>
        <div class="qa-hero-copy">
          <h2 class="qa-hero-title">Quick Add Patient</h2>
          <p class="qa-hero-subtitle">{{ quickAddWorkflowHint }}</p>
        </div>
      </div>
      <button
        type="button"
        class="qa-hero-close"
        (click)="closeQuickAddDialog()"
        aria-label="Close quick add dialog"
      >
        <i class="pi pi-times"></i>
      </button>
    </header>

    <div class="qa-body">
      <div class="qa-grid">
        <section class="qa-panel qa-panel--patient">
          <h3 class="qa-panel-title">Patient Information</h3>

          <div class="qa-field">
            <label class="qa-label" for="quick_full_name">
              Full name <span class="qa-required" aria-hidden="true">*</span>
            </label>
            <div class="qa-input-wrap">
              <i class="pi pi-user qa-field-icon" aria-hidden="true"></i>
              <input
                id="quick_full_name"
                class="qa-input"
                [(ngModel)]="quickPatient.full_name"
                placeholder="John Doe"
                autocomplete="off"
              />
            </div>
          </div>

          <div class="qa-field-row qa-field-row--split">
            <div class="qa-field qa-field--age">
              <label class="qa-label">
                Age <span class="qa-required" aria-hidden="true">*</span>
              </label>
              <app-patient-age-fields
                [compact]="true"
                [showPreview]="true"
                [(years)]="quickPatient.age"
                [(months)]="quickPatient.age_months"
                [(days)]="quickPatient.age_days"
              ></app-patient-age-fields>
            </div>
            <div class="qa-field">
              <div class="qa-contact-label-row">
                <label class="qa-label" for="quick_contact">
                  Contact <span class="qa-required" aria-hidden="true">*</span>
                </label>
                <button
                  type="button"
                  class="qa-foreign-chip"
                  [class.is-active]="quickIsForeignContact"
                  (click)="toggleQuickForeignContact()"
                >
                  Foreign
                </button>
              </div>

              <ng-container *ngIf="!quickIsForeignContact; else quickForeignContact">
                <div class="qa-input-wrap">
                  <i class="pi pi-phone qa-field-icon" aria-hidden="true"></i>
                  <input
                    id="quick_contact"
                    class="qa-input"
                    type="tel"
                    inputmode="numeric"
                    maxlength="10"
                    pattern="[0-9]*"
                    [(ngModel)]="quickPatient.contact_number"
                    (input)="onQuickContactInput($event)"
                    placeholder="10-digit mobile"
                    autocomplete="off"
                  />
                </div>
              </ng-container>

              <ng-template #quickForeignContact>
                <div class="qa-input-wrap">
                  <i class="pi pi-phone qa-field-icon" aria-hidden="true"></i>
                  <input
                    id="quick_contact"
                    class="qa-input"
                    type="tel"
                    inputmode="tel"
                    maxlength="16"
                    [(ngModel)]="quickPatient.contact_number"
                    (input)="onQuickForeignContactInput($event)"
                    placeholder="e.g. +971501234567"
                    autocomplete="off"
                  />
                </div>
                <small class="qa-field-hint">Include country code with + prefix</small>
              </ng-template>
            </div>
          </div>

          <div class="qa-subsection">
            <h4 class="qa-subsection-title">Billing Preference</h4>
            <button
              type="button"
              class="qa-option"
              [class.is-active]="quickPatient.is_free"
              (click)="quickPatient.is_free = !quickPatient.is_free"
            >
              <span class="qa-option-copy">
                <span class="qa-option-title">Free patient</span>
                <span class="qa-option-desc">{{ quickAddVisitFeeHint }}</span>
              </span>
              <span
                class="qa-option-check"
                [class.is-on]="quickPatient.is_free"
                aria-hidden="true"
              >
                <i class="pi pi-check" *ngIf="quickPatient.is_free"></i>
              </span>
            </button>
          </div>

          <div class="qa-subsection">
            <h4 class="qa-subsection-title">After registration</h4>
            <button
              type="button"
              class="qa-option"
              [class.is-active]="quickStartConsultation"
              (click)="quickStartConsultation = !quickStartConsultation"
            >
              <span class="qa-option-copy">
                <span class="qa-option-title"
                  >Start consultation automatically</span
                >
                <span class="qa-option-desc">
                  {{
                    quickStartConsultation
                      ? "Creates a walk-in appointment and opens the prescription form."
                      : "Only register — select the patient from search or queue later."
                  }}
                </span>
              </span>
              <span
                class="qa-option-check"
                [class.is-on]="quickStartConsultation"
                aria-hidden="true"
              >
                <i class="pi pi-check" *ngIf="quickStartConsultation"></i>
              </span>
            </button>
          </div>
        </section>

        <section class="qa-panel qa-panel--card">
          <h3 class="qa-panel-title">Card Assignment</h3>

          <div
            class="qa-mode-rail"
            role="tablist"
            aria-label="Card assignment mode"
          >
            <button
              type="button"
              role="tab"
              class="qa-mode-chip"
              [class.is-active]="isNewPatientCard"
              [attr.aria-selected]="isNewPatientCard"
              (click)="isNewPatientCard = true; onQuickNewPatientToggle()"
            >
              Create new
            </button>
            <button
              type="button"
              role="tab"
              class="qa-mode-chip"
              [class.is-active]="!isNewPatientCard"
              [attr.aria-selected]="!isNewPatientCard"
              (click)="isNewPatientCard = false; onQuickNewPatientToggle()"
            >
              Assign existing
            </button>
          </div>

          <div class="qa-card-pane" *ngIf="isNewPatientCard">
            <div class="qa-card-empty">
              <span class="qa-card-empty-icon" aria-hidden="true">
                <i class="pi pi-id-card"></i>
              </span>
              <p class="qa-card-empty-title">A new card will be created</p>
              <p class="qa-card-empty-desc">
                Save this patient and the system will issue a fresh card number
                automatically.
              </p>
            </div>

            <div
              class="qa-card-preview"
              *ngIf="(quickPatient.full_name || '').trim()"
            >
              <span class="qa-card-preview-kicker">Ready to register</span>
              <strong class="qa-card-preview-name">{{
                quickPatient.full_name
              }}</strong>
              <span
                class="qa-card-preview-meta"
                *ngIf="displayPatientAge(quickPatient.age, quickPatient.age_months, quickPatient.age_days) !== '—'"
              >
                Age {{ displayPatientAge(quickPatient.age, quickPatient.age_months, quickPatient.age_days) }}
                <ng-container *ngIf="quickPatient.contact_number">
                  · {{ quickPatient.contact_number }}</ng-container
                >
              </span>
            </div>
          </div>

          <div class="qa-card-pane" *ngIf="!isNewPatientCard">
            <div class="qa-field">
              <label class="qa-label" for="quickCardAssign"
                >Search card / patient</label
              >
              <div class="qa-field qa-field--search">
                <i class="pi pi-search qa-field-icon" aria-hidden="true"></i>
                <p-autoComplete
                  inputId="quickCardAssign"
                  [(ngModel)]="quickSelectedCard"
                  [suggestions]="quickFilteredCardList"
                  (completeMethod)="searchQuickCards($event)"
                  (onSelect)="onQuickCardSelect($event)"
                  field="label"
                  placeholder="Search by card number or patient name"
                  [forceSelection]="true"
                  [minLength]="1"
                  emptyMessage="No cards found"
                  appendTo="body"
                  styleClass="w-100 qa-ac"
                  inputStyleClass="qa-input"
                >
                  <ng-template let-item pTemplate="item">
                    <div class="quick-card-suggestion">
                      <div class="quick-card-suggestion-head">
                        <span class="quick-card-suggestion-id">
                          <i class="pi pi-id-card" aria-hidden="true"></i>
                          {{ item.number }}
                        </span>
                        <span class="quick-card-suggestion-count">
                          {{ item.patientCount }} patient{{
                            item.patientCount === 1 ? "" : "s"
                          }}
                        </span>
                      </div>
                      <div
                        class="quick-card-suggestion-patients"
                        *ngIf="item.patients?.length; else quickCardEmpty"
                      >
                        <div
                          class="quick-card-suggestion-patient"
                          *ngFor="
                            let cardPatient of $any(item.patients)
                              | slice: 0 : 3
                          "
                        >
                          <span class="quick-card-avatar">{{
                            getPatientInitials($any(cardPatient).full_name)
                          }}</span>
                          <div class="quick-card-patient-copy">
                            <span class="quick-card-patient-name">{{
                              $any(cardPatient).full_name
                            }}</span>
                            <span
                              class="quick-card-patient-meta"
                              *ngIf="$any(cardPatient).patient_number"
                            >
                              {{ $any(cardPatient).patient_number }}
                            </span>
                          </div>
                        </div>
                        <span
                          class="quick-card-more"
                          *ngIf="item.patients.length > 3"
                        >
                          +{{ item.patients.length - 3 }} more on this card
                        </span>
                      </div>
                      <ng-template #quickCardEmpty>
                        <span class="quick-card-suggestion-empty"
                          >No patients on this card yet</span
                        >
                      </ng-template>
                    </div>
                  </ng-template>
                </p-autoComplete>
              </div>
              <p class="qa-help">Search by card number or patient name.</p>
            </div>

            <div class="quick-selected-card fade-in" *ngIf="quickSelectedCard">
              <div class="quick-selected-card-head">
                <div>
                  <span class="quick-selected-card-label">Selected card</span>
                  <div class="quick-selected-card-number">
                    {{ quickSelectedCard.number }}
                  </div>
                </div>
                <span class="quick-card-suggestion-count">
                  {{ quickSelectedCard.patientCount }} patient{{
                    quickSelectedCard.patientCount === 1 ? "" : "s"
                  }}
                </span>
              </div>
              <div
                class="quick-selected-card-list"
                *ngIf="quickSelectedCardPatients.length"
              >
                <div
                  class="quick-selected-card-row"
                  *ngFor="
                    let cardPatient of quickSelectedCardPatients | slice: 0 : 4
                  "
                >
                  <span class="quick-card-avatar quick-card-avatar-lg">{{
                    getPatientInitials($any(cardPatient).full_name)
                  }}</span>
                  <div class="quick-card-patient-copy">
                    <span class="quick-card-patient-name">{{
                      $any(cardPatient).full_name
                    }}</span>
                    <span
                      class="quick-card-patient-meta"
                      *ngIf="$any(cardPatient).patient_number"
                    >
                      {{ $any(cardPatient).patient_number }}
                    </span>
                  </div>
                </div>
              </div>
            </div>

            <div
              class="qa-card-preview qa-card-preview--assign"
              *ngIf="quickSelectedCard && (quickPatient.full_name || '').trim()"
            >
              <span class="qa-card-preview-kicker">Will be added to</span>
              <strong class="qa-card-preview-name"
                >Card {{ quickSelectedCard.number }}</strong
              >
              <span class="qa-card-preview-meta">{{
                quickPatient.full_name
              }}</span>
            </div>
          </div>
        </section>
      </div>
    </div>
  </div>

  <ng-template pTemplate="footer">
    <div class="qa-footer">
      <span class="qa-footer-hint" *ngIf="!canSubmitQuickPatient">
        <i class="pi pi-info-circle" aria-hidden="true"></i>
        Name, age, and contact are required.
      </span>
      <div class="qa-footer-actions">
        <button
          type="button"
          class="qa-btn qa-btn--ghost"
          (click)="closeQuickAddDialog()"
        >
          Cancel
        </button>
        <button
          type="button"
          class="qa-btn qa-btn--save"
          [disabled]="!canSubmitQuickPatient"
          (click)="saveQuickPatient()"
        >
          <i class="pi pi-check" aria-hidden="true"></i>
          Save patient
        </button>
      </div>
    </div>
  </ng-template>
</p-dialog>

<div
  *ngIf="showFloatingTranscript && interimTranscript"
  class="floating-transcript"
  aria-live="polite"
>
  {{ interimTranscript }}
</div>

<app-report-viewer-dialog
  [(visible)]="reportViewerVisible"
  [loading]="reportViewerLoading"
  [title]="reportViewerTitle"
  [isImage]="reportViewerIsImage"
  [imageUrl]="reportViewerImageUrl"
  [documentUrl]="reportViewerDocumentUrl"
  [rawUrl]="reportViewerRawUrl"
  [errorMessage]="reportViewerError"
  (retryLoad)="onDialogRetry()"
  (closed)="closeReportViewer()"
></app-report-viewer-dialog>
